export default {
    "corporate": "Programme d'entreprise",
    "onboarding": {
        "goal_desc": "Non seulement le suivi de vos activités vous rapportera %{customPoints}, mais vous gagnerez aussi un bonus de %{customPoints} en atteignant vos objectifs. À vous de jouer : vous pouvez avoir 3 objectifs personnels actifs à la fois.",
        "sample_task": {
            "modalActivityTitle": "3 respirations profondes",
            "rewards_featured_title": "En vedette",
            "rewards_partners_title": "Les partenaires",
            "header_description": "Suivez vos activités et complétez des tâches, des défis et des objectifs pour obtenir des %{customPoints}.",
            "icon_text": "Touchez l'icône {icon} pour mesurer une inspiration profonde.",
            "activityName": "inspiration profonde",
            "activityUnit": "inspiration"
        },
        "lets_get_started": "C’est parti!",
        "start_description": "Suivez vos activités et complétez des tâches, des défis et des objectifs pour obtenir des %{customPoints}.",
        "complete_and_earn": "Terminer pour gagner",
        "did_it": "J'ai réussi!",
        "task_complete": "Tâche terminée.",
        "breath_sample_task": "Suivez un tutoriel rapide sur l'ajout d’activités",
        "track_a_sample_activity": "Ajoutez un exemple d'activité",
        "nice": "Super!",
        "nice_one": "Bravo!",
        "nice_subtext_1": "Vous avez obtenu %{points} %{customPoints}.",
        "nice_subtext_2": "Obtenir %{customPoints} vous aidera à augmenter de niveau. Chaque fois que vous passez au niveau supérieur, vous obtenez des %{reward_currency} que vous pourrez échanger contre des offres intéressantes.",
        "nice_subtext_3": "Vous obtenez plus de points lorsque vous terminez plus de tâches, ajoutez des activités et complétez les objectifs et les défis.",
        "progress_subtitle": "Vos %{customPoints} et vos progrès sont réinitialisés chaque %{frequency}.",
        "skip_for_now": "Ignorer pour le moment",
        "loadingText": "Patientez quelques secondes pendant que nous calculons votre score santé.",
        "goal_title": "Me fixer un objectif personnalisé",
        "swipe_for_more": "Balayer pour afficher la suite",
        "skip_goals": "J'ai fini de fixer mes objectifs pour le moment.",
        "complete_profile": "",
        "level": "Niveau",
        "finish_onboarding_action": "Veuillez d'abord vous inscrire",
        "vital_stats": {
            "height_ft": "Taille (pi)",
            "height_in": "Taille (po)"
        },
        "rewards": "",
        "welcome": {
            "disclaimerTitle": "Votre vie privée est importante"
        },
        "levels": {
            "title": "Médailles et récompenses",
            "tableTitle": "Médaille"
        },
        "initialScreen": {
            "title": "Bienvenue sur %{programName}, %{username}!",
            "getRewarded": "Obtenez des %{rewardName}",
            "completeAgainst": "Participez à une compétition amicale avec vos collègues",
            "earnPoints": "Obtenez des points avec des activités de bien-être",
            "levelUp": "Augmentez de niveau et débloquez des médailles"
        },
        "starterGoals": {
            "title": "Choisissez un objectif",
            "subtitle": "Commencez votre parcours vers le mieux-être du bon pied avec une nouvelle habitude santé."
        }
    },
    "healthkit_not_available": "Impossible de se connecter à Apple Santé. Dans l'application Apple Santé, sous Sources, assurez-vous que vous avez activé l'autorisation d'accès aux informations de santé et que vous avez effectué le suivi d’au moins un pas.",
    "changeCover": "Changer photo",
    "joiningCommunityToast": {
        "success": {
            "message": "Vous avez rejoint avec succès %{name}",
            "title": "Rejoindre la communauté"
        }
    },
    "achievement_starts_date": "Commence: %{date}",
    "editChallenge": "Modifier %{challengeName}",
    "createChallenge": {
        "activitiesOrCategory": {
            "subtitle": "Sélectionner jusqu'à 5 activités ",
            "title": "Que voulez-vous faire ?",
            "noActivityTitle": "Ajout d'activités",
            "noActivityMessage": "Sélectionnez au moins une activité ou une catégorie.",
            "categoryItemDescription": "Toutes les activités de la catégorie %{category}",
            "addActivityTitle": "Combien de %{unit} de %{activity} souhaitez-vous effectuer par %{period}?",
            "addCategoryQuantityTitle": "Combien de %{customPoints} souhaitez-vous gagner dans la catégorie %{category}?",
            "subtitleCategories": "Sélectionnez une catégorie. Toutes les activités de cette catégorie permettront d'atteindre l'objectif.",
            "subtitleWithActivities": "%{num} sur %{max} activités sélectionnées",
            "selectCategoryMessage": "Toutes les activités de la catégorie seront sélectionnées et les activités précédemment sélectionnées seront supprimées.",
            "addActivityTitleTotal": "Quel volume de l'activité %{activity} souhaitez-vous effectuer %{period}?"
        },
        "inviteDepartments": {
            "title": "Inviter des départements \/ divisions"
        },
        "inviteRegions": {
            "title": "Inviter des régions"
        },
        "createInvitation": {
            "selectMore": "Veuillez sélectionner au moins 2 %{entity}s!"
        },
        "visibility": {
            "title": "Visibilité",
            "description": "Les défis d'équipe sont visibles et accessibles à tous les utilisateurs %{programName}."
        },
        "highest": {
            "name": "Obtenir le plus de %{customPoints}",
            "description": "Aucune limite, la personne qui obtient le plus de %{customPoints} gagne la compétition"
        },
        "compete": {
            "individual": "Défi individuel",
            "team": "Défi de groupe"
        },
        "unitType": {
            "title": "Sélectionnez comment vous complétez votre objectif",
            "subtitle": "Choisissez parmi les activités ou une catégorie"
        },
        "category": {
            "name": "Toutes les activités d'une catégorie",
            "description": "Par ex., ajouter une activité de « Bouger »",
            "title": "Choisissez une catégorie",
            "subtitle": "Quelle catégorie d'activités ferez-vous?"
        },
        "activities": {
            "name": "Activités sélectionnées",
            "description": "Par ex., ajouter des activités précises telles le cyclisme",
            "title": "Choisissez des activités",
            "subtitle": "Nous vous recommandons de vous concentrer sur une seule activité, mais vous pouvez en ajouter jusqu'à cinq.",
            "maxModalTitle": "Nombre maximum d'activités sélectionnées",
            "maxModalDescription": "Vous pouvez ajouter au maximum 5 activités. Sélectionnez Accepter pour continuer avec vos 5 activités sélectionnées ou Modifier pour apporter des modifications.",
            "warningModalTitle": "Difficulté élevée",
            "warningModalDescription": "Vous avez sélectionné une quantité élevée d’activité à compléter par période pour cet objectif. Souhaitez-vous vraiment fixer un objectif si difficile? ",
            "requiredPoints": "requis pour atteindre %{challengeType} %{period}",
            "noActivitiesModalTitle": "Ajout d'activités",
            "noActivitiesModalDescription": "Sélectionnez au moins une activité."
        },
        "categoryQuantity": {
            "title": "Fixez votre objectif de %{customPoints}",
            "subtitle": "Combien de %{customPoints} voulez-vous gagner de %{category} à chaque %{period}?",
            "subtitleTotal": "Combien de {customPoints} voulez-vous gagner de %{category} %{period}?",
            "text": "À titre indicatif, 30 minutes d'activité modérée équivaut à environ 105 %{customPoints}",
            "noQuantityModalTitle": "Quantité",
            "noQuantityModalDescription": "Entrez une valeur",
            "defaultCategoryTitle": "catégorie actuelle"
        },
        "cancel": {
            "title": "Annuler la création du défi",
            "message": "Êtes-vous sûr de vouloir annuler la création du défi?"
        },
        "createNew": "Créer un nouveau défi",
        "chooseChallengeTitle": "Choisissez un défi ou créez le vôtre",
        "createOwn": {
            "title": "Créer mon propre défi"
        },
        "frequency": {
            "title": "À quelle fréquence souhaitez-vous réaliser votre objectif?",
            "subtitle": "Les objectifs quotidiens sont une excellente façon de développer des habitudes saines"
        },
        "startAndDuration": {
            "title": "Choisissez une date de début et une durée",
            "subtitle": "",
            "noFieldsTitle": "Date de début et durée",
            "noFieldsMessage": "Indiquez la date de début et la durée"
        },
        "finalize": {
            "title": "Vérifiez votre nouvel objectif",
            "subtitle": "",
            "noFieldsTitle": "Nom et instructions",
            "noFieldsMessage": "Indiquez le nom et les instructions",
            "name": "Mon objectif %{names} %{frequency}",
            "instructionCategory": "Gagnez %{points} %{customPoints} %{frequency} sur l'ensemble des activités de la catégorie %{category}",
            "instructionActivities": "Faites %{items} %{frequency} pour gagner %{points} %{customPoints} %{pointsFrequency}",
            "instructionCompetitionCategory": "Obtenez le plus de %{customPoints} sur l'ensemble des activités de la catégorie %{category} pour gagner cette compétition",
            "instructionCompetitionActivities": "Obtenez le plus de %{customPoints} parmi %{items} pour gagner cette compétition",
            "namePlaceholder": "Nommer votre compétition",
            "titleChallenge": "Finaliser votre défi"
        },
        "dailyDescription": "Par ex., boire 8 verres d'eau par jour",
        "weeklyDescription": "Par ex., marcher 150 minutes par semaine",
        "monthlyDescription": "Par ex., courir 150 km par mois",
        "totalDescription": "Par ex., rouler 10 000 km en vélo au total",
        "title": "Voulez-vous relever vous-même le défi ou le lancer à d'autres personnes?",
        "navigatorTitle": "Créer un défi",
        "me": {
            "name": "Seulement moi",
            "description": "Mettez-vous au défi avec un objectif personnel"
        },
        "others": {
            "name": "Lancez le défi",
            "description": "Participer à la compétition individuellement ou en équipe"
        },
        "one": {
            "name": "Individuellement",
            "description": "Participer à la compétition individuellement"
        },
        "team": {
            "name": "En équipe",
            "description": "Se mesurer à une équipe"
        },
        "company": {
            "name": "Défi de l'entreprise",
            "description": "Créer une compétition spéciale"
        },
        "adminItemTitle": "En tant qu'administrateur, vous pouvez créer",
        "userOrTeamTitle": "Participer à la compétition individuellement ou en équipe?",
        "target": {
            "name": "Fixer un objectif à atteindre",
            "description": "Défi avec une limite supérieure"
        },
        "typeTitle": "Sélectionner un type de %{challengeType}",
        "teamSizeTitle": "Sélectionner la taille de chaque équipe",
        "teamSizeSubtitle": "Les équipes doivent comprendre au minimum %{min} membres et au maximum %{max} membres. Les %{customPoints} d'une équipe représentent la moyenne de tous les membres et ne sont gagnés que lorsque l'équipe compte suffisamment de membres.",
        "teamSize": {
            "noFieldsTitle": "Min. et max.",
            "noFieldsMessage": "Choisissez le nombre minimum et maximum de membres d'une équipe"
        },
        "companyChallengeTitle": "Défi de l'entreprise",
        "companyChallengeSubtitle": "Vous êtes un administrateur. Vous pouvez donc organiser des défis par service et d'autres types de défis.",
        "chooseDepartmentTitle": "Lancer le défi à des services \/ division",
        "chooseRegionTitle": "Lancer le défi à des régions",
        "goToChallenge": "Accéder à mon défi",
        "additional": {
            "title": "Défi créé",
            "subtitle": "C'est parti! Invitez d'autres personnes à participer.",
            "makePublicName": "Rendre public",
            "makePublicDescription": "Tout le monde peut participer",
            "toDirectoryName": "Ajouter au répertoire de défis",
            "toDirectoryDescription": "Les utilisateurs peuvent en créer un comme celui-ci",
            "inviteTitle": "Inviter à relever un défi",
            "titleGoal": "Objectif créé!"
        },
        "quantityMinimum": {
            "message": "La quantité minimale requise est %{quantity}",
            "title": "Quantité insuffisante"
        },
        "toast": {
            "success": "Votre %{challengeType} a été créé."
        },
        "goToGoal": "Accéder à mon objectif",
        "navigatorTitleGoal": "Créer un objectif",
        "quantityError": {
            "wholeNumber": "Doit être un nombre entier",
            "greaterThanZero": "Doit être plus grand que 0"
        }
    },
    "wellbeing": {
        "description": {
            "overall": "Votre score santé est comparé au score de millions d'autres personnes et permet de vous situer par rapport aux autres personnes de votre âge et de votre sexe. Le score est calculé intelligemment et se met automatiquement à jour tous les mois en fonction de votre activité physique et de votre alimentation.",
            "excellent": "Votre score de santé est meilleur par rapport à 85% des personnes de votre âge et de votre sexe.",
            "very_good": "Votre score de santé est meilleur par rapport à 70 à 84% des personnes de votre âge et de votre sexe.",
            "good": "Votre score de santé est meilleur par rapport à 51 à 69% des personnes de votre âge et de votre sexe.",
            "fair": "Votre score de santé est meilleur par rapport à 31 à 50% des personnes de votre âge et de votre sexe.",
            "poor": "Votre score de santé est inférieur à 70% par rapport à celui des personnes de votre âge et de votre sexe. Il n'est jamais trop tard pour commencer à accorder la priorité à votre santé. Profitez de notre plateforme pour vous aider à progresser dans votre recherche du bien-être!",
            "overall_result": "Dans l'ensemble, votre score santé s'élève à %{status}.",
            "category_result": "Dans l'ensemble, votre score dans la catégorie {category} s'élève à {string}.",
            "goals": "Les objectifs sont essentiels. Fixez 3 objectifs personnels et mesurez vos progrès. Votre score augmentera au fur et à mesure que vous changez votre mode de vie."
        },
        "reminder": {
            "title": "Il est temps de mettre à jour votre questionnaire santé!",
            "updateAnswers": "Mettre à jour mes réponses"
        },
        "lastUpdated": "Dernière mise à jour %{date}",
        "scoreDescription": {
            "part1": "Votre score est",
            "part2": "score de",
            "belowAverage": "sous la moyenne",
            "aboveAverage": "au-dessus de la moyenne",
            "part3": "qu'obtiennent les gens de votre âge et de votre sexe."
        },
        "improveScore": {
            "description": "Votre score est calculé en fonction de vos réponses au questionnaire santé et des activités que vous avez ajoutées. Vous pouvez mettre à jour vos réponses au questionnaire ou fixer de nouveaux objectifs à améliorer.",
            "desc1": "Votre score ne peut pas être beaucoup plus elevé que cela! Pour garder vos routines intéressantes, mettez-vous au défi avec des objectifs qui dépassent juste un peu vos capacités normales et invitez les autres à rivaliser avec vous pour rester motivé.",
            "desc2": "Si vous êtes prêt à monter de niveau, il est temps d'augmenter le défi. Mettez-vous au défi avec des objectifs qui dépassent juste un peu vos capacités normales et invitez les autres à rivaliser avec vous pour rester motivé.",
            "desc3": "Fixez-vous des objectifs personnels et créez des défis publics pour vous responsabiliser et maintenir votre motivation. Assurez-vous de choisir des objectifs réalisables et des délais plus courts - nous recommandons 1 semaine.",
            "desc4": "Il est important d'être actif tous les jours. Si vous n'avez pas beaucoup de mouvement dans votre routine quotidienne, commencez par de petits objectifs qui correspondent à vos capacités et à vos intérêts. Assurez-vous de choisir des objectifs réalisables et des délais plus courts - nous recommandons 1 semaine."
        },
        "recommendedGoals": "Objectifs recommandés",
        "recommendedDescription": {
            "desc1": "Vous pouvez fixer jusqu’à ",
            "desc2": "3 objectifs ",
            "desc3": "pour améliorer votre bien-être. Vous avez actuellement "
        },
        "categoryScore": "Votre score %{category} est ",
        "learnMore": "En savoir plus",
        "youAreSet": "C'est fait!",
        "goalSetting": "Établissement d'objectifs",
        "attention": "score %{category} non disponible.",
        "move": {
            "error": "Sur la base de vos réponses, votre score bouger n’est pas disponible."
        },
        "eat": {
            "error": "Vous avez indiqué qu'un professionnel de la santé vous a dit que vous souffrez de diabète de type 2 et qu'il n’est pas géré."
        },
        "feel": {
            "error": "Sur la base de vos réponses, votre score ressentir n'est pas disponible."
        },
        "survey": {
            "requiredField": "* ce champ est requis "
        },
        "score_info_title": "Signification de mon score",
        "company_average_info": "Moyenne de mon entreprise",
        "demographic_average_info": "Moyenne de ma démographie",
        "score": "Score santé",
        "table": {
            "what_it_means": "Signification",
            "score": "Score"
        },
        "updated": "Mis à jour",
        "label": {
            "excellent": "Excellent",
            "very_good": "Très bien",
            "good": "Bien",
            "fair": "Passable",
            "poor": "Problématique"
        },
        "activity": {
            "eat": "Activité de manger 1, activité de manger 2, activité de manger 3",
            "move": "Activité de bouger 1, activité de bouger 2, activité de bouger 3",
            "feel": "Activité de ressentir 1, activité de ressentir 2, activité de ressentir 3"
        },
        "score_info_screen": "Comment est calculé mon score?",
        "details": "Détails",
        "activities": "Activités",
        "improveCategoryScore": "Améliorer mon score pour la catégorie %{category}",
        "meaning": {
            "heading": "Calcul du score"
        },
        "score_button": {
            "meaning": "Que signifie ce score?"
        },
        "improve": "Afficher les objectifs recommandés",
        "score_text": {
            "demographic": "Le score moyen pour votre âge et votre sexe est de",
            "company": "et le score moyen de votre entreprise est de"
        },
        "scoreHigher": "points au-dessus de la moyenne de",
        "scoreLower": "points en dessous de la moyenne de",
        "settedGoals": {
            "noGoals": "Aucun objectif fixé",
            "one": "1 objectif fixé",
            "n": "%{count} objectifs fixés"
        },
        "yourScoreIsPoor": "Votre score de %{category} est faible",
        "unlock": {
            "title": "Déverrouillez votre score de bien-être",
            "description": "Remplissez un bref questionnaire pour savoir comment votre état de santé général se compare à celui des autres personnes de votre groupe démographique."
        },
        "browseAndSet": "Vous pouvez parcourir et fixer des nouveaux objectifs une fois que vous avez atteint vos objectifs actuels.",
        "excellent": {
            "desc1": "Mode de vie exceptionnellement sain",
            "desc2": "Très faible risque pour la santé"
        },
        "veryGood": {
            "desc1": "Mode de vie très sain",
            "desc2": "Faible risque pour la santé"
        },
        "good": {
            "desc1": "Mode de vie sain",
            "desc2": "Risque moyen pour la santé"
        },
        "fair": {
            "desc1": "Mode de vie plutôt sain",
            "desc2": "Risque pour la santé plus élevé que la moyenne"
        },
        "poor": {
            "desc1": "Risque élevé pour la santé",
            "desc2": "Plus de mouvement quotidien est recommandé",
            "desc3": "Plus de mouvement quotidien est nécessaire"
        },
        "calculateScore": {
            "description": "Lorsque vous répondez à l'enquête sur le bien-être, vos réponses sont analysées à l'aide de milliards de variables de données provénant de personnes de votre âge et votre sexe. Le calcul prend également en compte l'activité que vous suivez dans %{programName}.\n\nVotre score de bien-être est mis à jour régulièrement afin que vous puissiez suivre son évolution au fil du temps."
        },
        "improveYourScore": "Améliorer votre score"
    },
    "challengerCount": "%{num} challengers",
    "team_name": "Nom de l'équipe",
    "syncingDeviceToast": {
        "danger": {
            "message": "Oups… un problème est survenu lors de la synchronisation de %{name}. Veuillez réessayer.",
            "title": "Synchroniser"
        },
        "success": {
            "title": "Synchroniser",
            "message": "Synchronisation réussie de %{name}. Vos activités sont désormais à jour."
        }
    },
    "allCompanyMembers": "Tous les membres de l'entreprise",
    "allCompanyMembersTeam": "Tous les membres de l'entreprise (Équipe)",
    "successfullyRedeemedItemForConfirmation": "Vous avez bien échangé cet article. Nous vous avons envoyé un courriel de confirmation à l'adresse %{email}.",
    "no_all_events_placeholder": "Il semble qu’aucun événement ne soit disponible pour le moment. Pourquoi ne pas en créer un?",
    "confirmDeleteAccount": "Terminez votre demande de suppression en saisissant le courriel associé à votre compte.",
    "deleteAccount": "Supprimer le compte",
    "linkAccounts": "Gérer les comptes associés",
    "titleSlug": {
        "icon_reward_text": "Il est facile pour les membres admissibles d’accumuler plus de points en effectuant des achats avec nos partenaires, ou lors d'un rendez-vous chez un dentiste de Members’ Choice Advantage en utilisant leur couverture supplémentaire.",
        "icon_move_text": "Faire le suivi de choix sains au quotidien, comme mieux dormir ou manger des légumes, pourrait vous permettre d'accumuler des points Live Better.",
        "icon_redeem_text": "Live Better récompense les membres de la Medibank qui ont une couverture hospitalière ou supplémentaire pour prendre soin de leur santé.",
        "icon_phone_text": "Inscrivez-vous et obtenez des récompenses, comme des cartes-cadeaux santé et bien-être ou des économies sur votre couverture santé.",
        "wellness": "Bienvenue dans le monde du bien-être",
        "goals": "Atteignez vos objectifs",
        "devices": "Rester sur la bonne voie",
        "challenges": "Créez des défis",
        "celebrate": "Bien-être partagé",
        "habits": "Développez des habitudes saines",
        "joinChallenge": "Relevez le défi",
        "getSocial": "Socialisez",
        "reward": "Obtenez des récompenses en adoptant un mode de vie plus sain.",
        "move": "Bougez, mangez et sentez-vous mieux.",
        "phone": "Vivez mieux, sentez-vous mieux."
    },
    "viewProgress": {
        "goal": "Voir la progression de l'objectif",
        "challenge": "Voir la progression du défi",
        "progress": "Afficher la progression"
    },
    "vitalStats": {
        "disclaimer": {
            "message": "La saisie de ces informations n’est pas obligatoire, mais plutôt pour votre propre bénéfice et celles-ci demeurent privées."
        }
    },
    "eventBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} %{customPoints} bonus sont disponibles pour cet événement!"
        },
        "modal": {
            "paragraph1": "En participant à cet événement, vous gagnerez des %{pointsName} bonus.",
            "paragraph2": "Tous les %{pointsName} bonus sont attribués à la fin de l'événement. Vous ne recevrez pas de crédits en bonus pour les événements auxquels vous ne participez pas."
        }
    },
    "EAP": {
        "contactInfo": "Coordonnées",
        "doLater": "Plus tard",
        "tellMore": "En savoir plus",
        "contactMe": "Communiquer avec moi",
        "title": "Programme d’aide aux employés et à la famille",
        "reachGoal": {
            "title": "De l’aide à votre portée",
            "description": "Votre programme d’aide aux employés et à la famille (PAEF), offert par %{providerName}, propose une gamme de services de coaching santé pour vous aider à atteindre vos objectifs de bien-être.\n\nVoulez-vous que %{providerName} vous contacte afin de vous fournir plus d’informations?"
        },
        "privacyPolicy": "Politique de confidentialité %{provider}"
    },
    "HRIS": {
        "disclaimer": "Certains champs sont mis à jour automatiquement et ne peuvent pas être modifiés."
    },
    "settingGoals": {
        "description": "Établir des objectifs demande de la concentration. Se concentrer sur un maximum de 3 objectifs structurés à la fois augmentera vos chances de succès.",
        "title": {
            "one": "Vous avez 1 objectif défini"
        }
    },
    "auth": {
        "linkAccount": {
            "alreadyLinkedToUser": "Le compte est déjà associé à un autre utilisateur ",
            "lastAccountMessage": "Souhaitez-vous vraiment supprimer le dernier compte associé? Une fois supprimé, vous devez vous connecter avec l’adresse de courriel %{email} et un nouveau mot de passe.  ",
            "unlinkCorpAccountMessage": "Souhaitez-vous vraiment supprimer votre compte d’entreprise associé? Une fois supprimé, vous devez vous connecter à nouveau avec l’adresse de courriel %{email}.",
            "alreadyLinked": "Compte déjà associé",
            "unlinkMessage": "Voulez-vous vraiment supprimer un compte associé? "
        },
        "sso": {
            "emailNotVerified": "Votre courriel n’est pas confirmé."
        },
        "signIn": {
            "dontHaveAccount": "Vous n'avez pas de compte?",
            "enterPIN": "Entrez votre numéro d'identification (NIP) de programme d'entreprise",
            "dontKnowPIN": "Vous ne connaissez pas votre code NIP?",
            "pin": "NIP",
            "register": "S'inscrire",
            "pinDescription": "Contactez votre administrateur de programme si vous n'êtes pas sûr du numéro d'identification de programme (NIP) unique de votre entreprise. Si vous avez un code NIP et vous avez des difficultés à passer à l'étape suivante, contactez support@sproutatwork.com.",
            "keepMeTooltip": "Pour votre commodité, lorsque cette case est cochée, votre session reste valide pendant 30 jours. Sur les appareils partagés, nous vous recommandons de décocher cette case et de vous déconnecter lorsque vous avez terminé."
        },
        "signUp": {
            "backToLogin": "Retour à la page de connexion",
            "termsOfService": "Conditions d'utilisation",
            "privacyPolicy": "Politique de confidentialité"
        },
        "createYourAccount": "Créez votre compte",
        "setYourDetails": "Définissez vos coordonnées",
        "ModaHybridLogin": {
            "noAccessDashboard": "Vous n’avez pas accès au tableau de bord des membres ?",
            "signUpSSOButton": "Inscrivez-vous via le tableau de bord des membres de Moda",
            "noAccessDashboardWeb": "Si vous n’avez pas accès au tableau de bord des membres, connectez-vous avec votre e-mail et votre mot de passe ci-dessous.",
            "loginSSOButton": "Connectez-vous via le tableau de bord des membres de Moda"
        }
    },
    "entityHasBeenDeleted": "%{name} a été supprimée",
    "track_challenge": {
        "message": {
            "manually": "Ajouter manuellement",
            "automatically": "Suivi effectué automatiquement avec %{appOrDeviceName}",
            "manuallyOrConnect": "Ajouter manuellement ou connecter une application ou un appareil",
            "manuallyAndBy": "Ajouter manuellement et automatiquement avec %{appOrDeviceName}",
            "reconnectDevice": "Appareil requis. Veuillez reconnecter votre appareil",
            "manualAndAuto": "Suivi manuel et automatique",
            "trackedAutomatically": "Suivi automatique"
        }
    },
    "signUpPartnerSSOToast": {
        "danger": {
            "title": "Impossible de s'enregistrer",
            "message": "Impossible de récupérer les détails de l'utilisateur du site partenaire. Veuillez réessayer plus tard"
        }
    },
    "app_device_required": {
        "disclaimer": {
            "title": "L'objectif %{goalName} nécessite une application ou un appareil.",
            "subTitle": "Connecter une application ou un appareil"
        }
    },
    "descriptionSlug": {
        "wellness": "Rejoignez la communauté santé en milieu de travail pour vous aider à fixer des objectifs, à connaître vos collègues et à rester sur la bonne voie.",
        "goals": "Dites-nous ce que vous voulez réaliser et nous vous aiderons à y arriver avec des objectifs recommandés.",
        "devices": "Synchronisez votre appareil de suivi ou entrez vos activités pour rester centré sur vos objectifs.",
        "challenges": "Générez une compétition amicale avec vos amis en créant des défis.",
        "celebrate": "Restez connecté avec vos collègues et célébrez vos réussites ensemble. ",
        "habits": "Faites le suivi d’activités de mieux-être pour obtenir des points.",
        "joinChallenge": "Voyez où vous vous situez par rapport à vos collègues lors de compétitions amicales.",
        "getSocial": "Restez connecté avec vos collègues et célébrez vos réussites ensemble.",
        "reward_text": "Gagnez des points lorsque vous terminez des activités quotidiennes et relevez des défis personnels.",
        "move_text": "Qu’il s’agisse de faire un tour dans votre quartier, de cinq minutes de pleine conscience ou de manger des plats sains, vous serez récompensé.",
        "phone_text": "Dépensez vos points pour obtenir des réductions sur votre couverture et bénéficier d'offres exceptionnelles. À vous de choisir.",
        "none": ""
    },
    "core": {
        "featureNotEnabled": "Fonction non activée",
        "checkAppVersion": {
            "message": "Il semble que votre application soit obsolète. Veuillez installer la dernière mise à jour.",
            "button": "Mettre à jour %{appName}"
        },
        "noConnection": {
            "title": "Pas de connexion réseau",
            "description": "Il semble que vous n'êtes pas connecté à Internet. Vous ne pourrez utiliser pleinement l'application que si vous avez une connexion.",
            "button": "Réessayez"
        },
        "uploadPhotoText": "Télécharger une photo pour votre %{entityType}",
        "entities": {
            "community": "communauté",
            "event": "événement",
            "team": "équipe",
            "goal": "objectif",
            "challenge": "défi",
            "competition": "сompétition"
        }
    },
    "registration": {
        "login": {
            "errorHeading": "Impossible de se connecter",
            "resetPasswordHeading": "Réinitialisation du mot de passe requise"
        },
        "signup": {
            "corporateOrOther": "Vous n’êtes pas membre de Medibank? Ou d’un programme d'entreprise?",
            "sign_up_here": "S'inscrire ici",
            "errorHeading": "Impossible de s'inscrire",
            "areYouMedibankMember": "Êtes-vous membre de Medibank?",
            "isMedibankMember": "Je suis membre",
            "isNotMedibankMember": "Je ne suis pas membre"
        },
        "bpidExists": "L’adresse de courriel fournie est déjà associée à un utilisateur Live Better. L'adresse doit être unique.",
        "generalError": "Service actuellement indisponible"
    },
    "rewardsNoAvailableProducts": "Il n'y a aucun produit disponible pour le moment.",
    "endedGoal": {
        "timeToTrack": {
            "yes": "Vous avez encore du temps pour faire le suivi!",
            "no": "Votre %{type} est terminé"
        },
        "grace": "Votre %{type} est peut-être terminé, mais vous avez %{n} %{text} pour ajouter toute activité oubliée.",
        "notGrace": {
            "goal": "Félicitations, vous avez atteint votre objectif! Continuez votre excellent travail en vous fixant un nouvel objectif: rester sur la bonne voie pour assurer votre mieux-être.",
            "competition": "Félicitations, vous avez complété le défi! Gardez votre élan en rejoignant un autre défi ou créez-en un."
        }
    },
    "appDeviceModal": {
        "defaultMessage": "Connectez votre appareil ou application et profitez d'un suivi en continu. Votre authentification permet à notre partenaire technologique \"Sprout\" de transférer en toute sécurité vos données depuis votre compte %{appDeviceTitle}."
    },
    "noTransactionsMessage": "Il semble que vous n’ayez effectué aucune transaction.",
    "noRedemptionsMessage": "Il semblerait que vous n’avez pas encore effectué d’échange.",
    "challengeCarousel": {
        "emptyChallenge": {
            "subtitle": "Vous pouvez participer à des défis en tant qu'individu ou en équipe",
            "prompt": "Il n'y a pas de défis à relever en ce moment. Pourquoi ne pas en créer un?"
        },
        "createChallengeButton": "Créez un défi"
    },
    "eventCarousel": {
        "emptyEvents": {
            "subtitle": "Les événements peuvent être uniquement sur invitation ou ouverts à tous.",
            "button": "Créez un événement"
        },
        "emptyEventsMessage": "Il n'y a pas d'événements à rejoindre en ce moment. Pourquoi ne pas en créer un?"
    },
    "appnameLiveBetter": "Live Better",
    "appnameTelus": "Bien-être",
    "appnameUPnGo": "UPnGO",
    "personal_goal": {
        "carousel": {
            "headingNoSet": "Vous n'avez pas d'objectifs fixés!",
            "descriptionNoSet": "Améliorez votre score santé en vous fixant des objectifs. Commencez rapidement avec un objectif recommandé, choisissez-en un dans le catalogue ou créez le vôtre.",
            "descriptionSet": "Vous pouvez fixer l'un des objectifs recommandés que nous proposons pour vous, parcourir le catalogue complet ou créer votre propre objectif.",
            "action_text": "Fixer un nouvel objectif",
            "heading_singular": "Vous pouvez fixer 1 objectif supplémentaire",
            "heading_plural": "Vous pouvez fixer %{number} objectifs supplémentaires"
        },
        "heading": "Objectifs personnels",
        "single": "Objectif personnel"
    },
    "settingGoal": {
        "yourGoal": "Votre %{unités}",
        "yourGoalDescription": "Vous êtes bien parti! Les %{unités} suivants seront fixés et commenceront immédiatement.",
        "selectedGoals": "Objectifs sélectionnés",
        "recommendedDescription": {
            "maximumSet": "Vous avez le nombre maximum d'objectifs fixés. Vous pouvez parcourir et définir de nouveaux objectifs une fois que vos objectifs actuels sont terminés.",
            "maximumSetTitle": "Vous avez %{count} objectifs fixés."
        }
    },
    "activityLogRemoved": {
        "single": {
            "success": "L’activité a été supprimée ",
            "info": "Une erreur s'est produite. Veuillez réessayer.",
            "danger": "Une erreur s'est produite. Veuillez réessayer."
        },
        "plural": {
            "success": "Les activités ont été supprimées",
            "info": "Une erreur s'est produite. Veuillez réessayer.",
            "danger": "Une erreur s'est produite. Veuillez réessayer."
        },
        "success": "L’activité a été supprimée ",
        "info": "L'activité n'a pas été supprimée. Veuillez réessayer.",
        "danger": "L'activité n'a pas été supprimée. Veuillez réessayer."
    },
    "participants": "Participants",
    "members": "Membre(s)",
    "timeSittingInformationOld": "Les lignes directrices recommandent de :\n - Réduire au minimum le temps passé en position assise prolongée.\n - Interrompre les longues périodes d'assise aussi souvent que possible.",
    "timeSittingInformation": {
        "title": "Il est recommandé de:",
        "list": "- Réduire le temps passé assis.\n- Interrompre les longues périodes assises aussi souvent que possible."
    },
    "activityLevelInformationOld": "Les lignes directrices recommandent de\n - Être actif la plupart des jours, de préférence tous les jours de la semaine.\n - Accumuler plus de 150 minutes d'activité physique d'intensité modérée chaque semaine.\n - Faire des activités de renforcement musculaire au moins deux jours par semaine.",
    "activityLevelInformation": {
        "title": "Il est recommandé de:",
        "list": "- Être actif presque tous les jours, de préférence tous les jours.\n- Accumuler plus de 150 minutes d'activité physique d'intensité modérée chaque semaine.\n- Faire des activités de renforcement musculaire au moins deux jours par semaine."
    },
    "viewGuidelines": "Voir les recommandations",
    "corporateAccountLink": {
        "verification": {
            "title": "Confirmez votre adresse de courriel d'entreprise ",
            "description": "Il faut confirmer votre adresse de courriel d'entreprise pour compléter le processus de liaison. Veuillez suivre les instructions envoyées à:"
        }
    },
    "invitation": {
        "findFriendsAndFamily": "Trouvez des amis et des membres de votre famille",
        "findFriends&Family": "Trouvez des amis et des membres de votre famille",
        "tapToAddFriendsAndFamily": "Touchez pour ajouter aux amis et à la famille ",
        "addedFriendsAndFamily": "Ajouté aux amis et à la famille ",
        "whoYouAreLookingFor": "Vous ne voyez pas qui vous cherchez?",
        "inviteWithEmail": "Inviter par courriel ",
        "sentInvitations": "Invitations envoyées",
        "foundPerson": "Nous avons trouvé cette personne avec un courriel correspondant",
        "youAreBoth": "Vous êtes tous les deux dans %{entityName}",
        "youAreBothMore": "Vous êtes tous les deux dans %{entityName}, +%{n} plus",
        "noFriendsAndFamilyAdded": "On dirait que vous n'avez pas encore d'amis ou de famille ajoutés.",
        "sendInvitation": "Envoyer une invitation",
        "youHaveNoSentInvitations": "Vous n'avez envoyé aucune invitation",
        "toast": {
            "success_title": "Invitation envoyée",
            "success_description": "%{invite_email} verra l'invitation dans sa boîte de réception",
            "danger_title": "L'invitation a échoué",
            "danger_description": "Veuillez réessayer plus tard"
        },
        "email": {
            "invalid_email": "Veuillez entrer une adresse de courriel valide "
        },
        "inviteOthers": "Inviter",
        "searchForSomeone": "Rechercher des utilisateurs",
        "searchForOthersToInvite": "Rechercher d'autres personnes à inviter",
        "programNameOnly": {
            "title": " %{programName} seulement",
            "description": "Ce %{entityType} est uniquement disponible pour les personnes faisant partie de %{programName}"
        },
        "domainCannotBeUsed": "Ce domaine ne peut pas être utilisé avec %{programName}",
        "actionSearchByEmail": "Si vous ne trouvez pas un utilisateur en le recherchant, vous pouvez l'inviter par courriel",
        "send": "Envoyer",
        "addEmailToList": "Ajouter un courriel à la liste ",
        "toBeSent": "Invitations à envoyer",
        "noInvitationsToBeSent": "Aucune invitation",
        "removeEmailConfirmation": "Êtes-vous sûr de vouloir supprimer ce courriel de la liste?",
        "yes": "Oui",
        "no": "Non",
        "foundByEmail": "Nous avons trouvé cette personne avec un courriel correspondant",
        "addToFriendsAndFamily": "Ajouter aux amis et à la famille",
        "alreadyAddedEmail": "Vous avez déjà ajouté ce courriel à la liste"
    },
    "pointsCurrencyAdditionalInfo": "Votre %{points_name} et vos niveaux commencent à zéro à chaque %{période}. Toutes vos activités ajoutées contribuent à votre niveau général au cours de la période.",
    "rankLabel": "Rang",
    "leaderboards": {
        "loadingLabel": "Chargement des classements ... Cela peut prendre quelques minutes - il semble que tout le monde se lance dans l’activité physique!"
    },
    "feeds": {
        "emptyListHomePage": "Il n'y a aucune publication à afficher pour le moment. Essayez d’ajuster le filtre pour afficher plus de publications.",
        "viewingPostsFrom": "Afficher les publications de",
        "postActivity": "Ajoutez un commentaire ou une photo de vos activités!",
        "indicatorLoader": {
            "defaultTitle": "Actualisation…",
            "successfulLoadedTitle": "Synchronisé et actualisé…"
        },
        "inapropriateTextError": {
            "message": "Le contenu de votre message peut être inapproprié, veuillez utiliser un langage plus convivial."
        },
        "postImageError": {
            "title": "Désolés, nous ne pouvons pas publier cela",
            "message": "L’image que vous avez importée peut être considérée comme inappropriée, choisissez-en une autre."
        }
    },
    "syncModal": {
        "connect": {
            "title": "Connecter %{name}",
            "description": "Pour connecter vos données %{name} à votre compte, procédez comme suit:",
            "firstStep": "Téléchargez et installez l'application mobile %{appName} à partir de %{storeName}",
            "fourthStep": "Sélectionnez pour vous connecter avec %{name}",
            "fifthStep": "Lorsque vous y êtes invité, sélectionnez les données santé à synchroniser avec %{appName} et appuyez sur 'Terminé'.",
            "additionalInfo": "Veuillez noter que pour déclencher la synchronisation à partir de l'application Santé, %{appName} doit être ouvert. Bien que vous n'ayez pas besoin de garder l'application ouverte, la synchronisation peut prendre une heure pour se terminer et apparaître dans votre journal d'activité."
        },
        "title": "Synchronisation de %{name}",
        "description": "Pour synchroniser vos données %{name} avec votre compte, procédez comme suit:",
        "steps": {
            "one": "Connectez-vous à votre application %{appName} sur votre téléphone",
            "two": "Ouvrez la section Applications et appareils de votre profil",
            "three": "Appuyez sur le bouton de synchronisation à côté de %{name}",
            "iPhone": "Connectez-vous à votre application %{appName} sur votre iPhone"
        }
    },
    "accountLinkingToast": {
        "success": {
            "title": "Compte d’entreprise",
            "message": "Compte connecté"
        },
        "danger": {
            "message": "Erreur lors de la connexion du compte"
        },
        "conflict": {
            "message": "Le compte est déjà associé à un autre utilisateur"
        }
    },
    "accountUnlinkingToast": {
        "success": {
            "title": "Compte d’entreprise",
            "message": "Compte déconnecté"
        },
        "danger": {
            "title": "Lier vos comptes",
            "message": "Erreur lors de la déconnexion du compte"
        }
    },
    "earnMoreWithPartners": "Gagnez davantage avec des partenaires ",
    "connectPartnersToEarnByShopping": "Connectez vos comptes et gagnez plus de %{unit_type} en effectuant des achats avec des partenaires %{program_name}.",
    "viewAllPartners": "Voir tous les partenaires",
    "myPartnerMemberships": "Mes adhésions partenaires",
    "linkAccount": "Lier le compte",
    "linkToPartner": "Lien vers le partenaire",
    "linkingError": "Un problème est survenu lors de la connexion de votre compte. Veuillez réessayer.",
    "linkPending": "Lien en attente",
    "unlinkAccount": "Dissocier le compte",
    "linkedToPartnerName": "Lié à %{partner_name}",
    "linked": "Lié",
    "permission": {
        "facebookTitle": "Inscrivez-vous avec Facebook",
        "googleTitle": "Inscrivez-vous avec Google",
        "facebookDescription": "Lors de votre inscription à Facebook, vous devez autoriser notre partenaire technologique \"Sprout\" à accéder à votre identité et à créer votre compte %{programName}.",
        "googleDescription": "Lors de votre inscription à Google, vous devez autoriser notre partenaire technologique \"Sprout\" à accéder à votre identité et à créer votre compte %{programName}.",
        "camera": {
            "title": "Accès caméra",
            "description": "Pour prendre une photo, l'accès à la caméra est requis. Dans les paramètres de l'iPhone, touchez sur %{appName} et activez l'appareil photo."
        },
        "notNow": "Pas maintenant",
        "openSettings": "Ouvrir les paramètres",
        "photos": {
            "title": "Veuillez autoriser l'accès aux photos",
            "description": "Cela vous permet de partager des photos de votre bibliothèque et d'enregistrer des photos sur votre pellicule. Dans les paramètres de l'iPhone, touchez sur %{appName} et basculez les photos sur Lecture et écriture."
        }
    },
    "firstNameContainsSpecialChar": "Votre prénom ne peut contenir que des lettres, des traits d'union et des apostrophes",
    "lastNameContainsSpecialChar": "Votre nom de famille ne peut contenir que des lettres, des traits d'union et des apostrophes",
    "goToPartnerSite": "Accéder au site partenaire",
    "noPartnersFound": "Aucun partenaire trouvé",
    "noLinkedPartners": "Aucun partenaire lié",
    "noPartnersInCategory": "Pas de partenaire dans la catégorie",
    "partnerAccountPendingVerification": "Vérification du compte en attente",
    "shopWithPartner": "Magasinez le site d’un partenaire",
    "shopWithPartnerName": "Magasinez le site de %{partner_name}",
    "linkToPartnerName": "Lien vers %{partner_name}",
    "earnPartnerMembershipIdentifier": "Identifiant d'adhésion",
    "earnPartnerAccountPendingAddLink": "La liaison de votre compte d’adhésion est en cours. Cela peut prendre plusieurs jours.",
    "earnPartnerAccountPendingRemoveLink": "La dissociation de votre compte d’adhésion est en cours. Cela peut prendre plusieurs jours.",
    "linkStatusUpdating": "Mise à jour de l'état des liens",
    "activityTracking": {
        "firstActivityModal": {
            "description1": "Félicitations, vous avez ajouté vos premières activités! \n\nSi vous le souhaitez, vous pouvez ajouter d'autres activités pour aujourd’hui et d’autres jours. Une fois les activités ajoutées pour aujourd’hui, touchez",
            "description2": "l'écran suivant lorsque vous n'avez plus rien à ajouter."
        },
        "listTitle": "Activités suivies sur",
        "dots": {
            "tracked": "Activités ajoutées ce jour-là",
            "added": "Des activités ont été ajoutées et sont en attente de soumission"
        },
        "trackedActivitiesFor": "Activités ajoutées pour %{date}",
        "activityTracking": "Suivi d'activité",
        "addedPending": "Ajouté (soumission en attente)",
        "search": {
            "description1": "Touchez",
            "description2": "pour voir les activités disponibles ou cherchez une activité précise"
        },
        "addActivity": "Ajouter une activité",
        "addAnotherActivity": "Ajouter une autre activité"
    },
    "rewardsBalance": "%{currencyName} solde: %{points}",
    "membershipIdentifierRequiredError": "Votre identifiant de membre est requis pour lier",
    "incorrectValueInRange": "Veuillez entrer une valeur entre %{min} et %{max}",
    "joinTeam": {
        "title": "Rejoindre l'équipe",
        "createInsteadText": "Rejoignez ou créez une équipe pour participer à ce défi"
    },
    "teamRank": "Rang d'équipe",
    "teamScore": "Score d'équipe",
    "appsDevices": {
        "infoText": "Il vous sera demandé d'autoriser notre partenaire technologique Sprout Wellness Solutions, Inc. à accéder à vos données de bien-être lors de l'ajout d'une application ou d'un appareil.",
        "connectModal": {
            "title": "Autorisation",
            "paragraph1Part1": "Il vous sera demandé d'autoriser notre partenaire technologique",
            "paragraph1Part2": "Sprout Wellness Solutions, Inc.",
            "paragraph1Part3": "à accéder à vos données de bien-être.",
            "paragraph2Desc1": "Votre autorisation permet à",
            "paragraph2Desc2": "Sprout",
            "paragraph2Desc3": "de synchroniser vos données ",
            "paragraph2Desc4": "en toute sécurité avec",
            "paragraph2Desc5": ", et vous aide à gagner plus de %{pointsName}!"
        },
        "statusAlert": {
            "connectMessage": "Connectez une application ou un appareil de suivi d'activité pour facilement effectuer la synchronisation et le suivi des activités",
            "connectAction": "Connecter une application ou un appareil",
            "errorMessage": "Certains de vos appareils ou de vos applications connectés ne peuvent pas être synchronisés",
            "warningMessage": "Certains de vos appareils ou de vos applications connectés peuvent avoir un problème de connexion",
            "errorAction": "Corriger cette erreur",
            "warningAction": "Corriger cet avertissement ",
            "syncingError": "Erreur de synchronisation",
            "syncingIssue": "Problème de synchronisation"
        },
        "deviceDetails": {
            "warningMessage": "Cette application ou cet appareil a des problèmes de synchronisation",
            "errorMessage": "Cette application ou cet appareil ne peut pas être synchronisé",
            "warningAction": "Ignorer l'avertissement ",
            "noActivities": "Aucune activité %{deviceName} n'a été synchronisée avec %{programName} au cours des 7 derniers jours.\r\n\r\nCela peut prendre jusqu'à une heure pour que les activités s'affichent ici après leur ajout avec %{deviceName}.\r\n\r\nSi vous avez une autre application ou un autre appareil connecté, et que plusieurs pas ont été ajoutés par l'autre application ou appareil, vous y verrez l'activité. Sinon, essayez de déconnecter et de reconnecter %{deviceName}. Si vous êtes invité à vous authentifier ou à accorder des autorisations, assurez-vous d'activer les données d'activité et d'utiliser le même compte pour s'authentifier que celui utilisé pour ajouter les activités. Consultez les étapes de dépannage pour plus d'informations."
        },
        "troubleshooting": "Dépannage",
        "deviceItem": {
            "error": "Erreur de connexion",
            "warning": "Avertissement de connexion",
            "unableToSync": "Impossible de synchroniser"
        },
        "platformDevice": {
            "defaultApp": "L'appli santé par défaut de votre appareil est",
            "continueMore": "Continuer vers plus d'applications et d'appareils"
        }
    },
    "friendsAndFamily": {
        "learnMore": "En savoir plus sur les amis et la famille",
        "learnModal": {
            "title": "À propos des amis et de la famille",
            "description": "Après avoir ajouté une personne à vos amis et à votre famille, vous pouvez choisir de partager vos publications sur %{programName} avec eux uniquement.\n\nVous pouvez également filtrer les publications que vous voyez sur %{programName} uniquement aux personnes de votre liste d'amis et de  famille si elles ont été publiées pour tout le monde ou pour vous.",
            "description_line1": "Après avoir ajouté une personne à vos amis et à votre famille, vous pouvez choisir de partager vos publications sur %{programName} avec eux uniquement.",
            "description_line2": "Vous pouvez également filtrer les publications que vous voyez sur %{programName} uniquement aux personnes de votre liste d'amis et de famille si elles ont été publiées pour tout le monde ou pour vous.",
            "whatIconsMean": "Ce que signifie les icônes",
            "canAdd": "Ajouter",
            "added": "Ajouté"
        },
        "searchDescription1": "Recherchez des personnes à ajouter à vos amis et à votre famille.",
        "searchDescription2": "Vous ne voyez pas qui vous cherchez? Invitez-les par courriel.",
        "friends&Family": "Amis et famille ",
        "managingTour": {
            "title": "Gérer les amis et la famille",
            "body": "Si vous souhaitez supprimer une personne de vos amis et de votre famille, touchez l'icône"
        },
        "removeOption": "Supprimer de la famille et des amis",
        "inviteDescription1": "Recherchez vos amis et votre famille.",
        "inviteDescription2": "Vous ne voyez pas qui vous cherchez ?"
    },
    "deletePlatformInvitationToast": {
        "success": {
            "message": "Les publications que vous partagez uniquement avec vos amis et votre famille ne seront plus visibles par %{userFirstName}."
        }
    },
    "skipAll": "Non merci",
    "smallMin": "min",
    "eap": {
        "skipModal": {
            "title": "Êtes-vous sûr?",
            "description": "Vous pouvez toujours contacter le Programme d’aide aux employés et à la famille à partir de votre profil lorsque vous en avez besoin."
        },
        "contact": {
            "whatIsBestNumber": "Quel est le meilleur numéro pour vous contacter?",
            "whatIsBestTime": "Quel est le meilleur moment pour vous contacter?",
            "morning": "Matin",
            "afternoon": "Après-midi",
            "evening": "Soirée",
            "additionalDetails": "Détails supplémentaires sur l'heure et la date auxquelles vous souhaitez être contacté",
            "message": "Contactez-moi le %{weekDay} au %{phoneNumber}. Informations supplémentaires: %{additional}",
            "description": "Remarque : nous vous encourageons vivement à choisir un horaire en dehors des heures de travail et d'opter pour un lieu adapté aux discussions privées. Veuillez inclure votre fuseau horaire."
        },
        "phoneNumber": {
            "empty": "Ce champ ne peut pas être vide",
            "missingDigits": "Le numéro de téléphone doit contenir au moins 4 chiffres"
        },
        "myEAP": "Mon programme d'aide aux employés et à la famille"
    },
    "healthSurveySkipAllTitle": "Passer le questionnaire santé",
    "healthSurveySkipAllAlert": "Êtes-vous sûr de vouloir ignorer toutes les questions restantes du questionnaire santé? ",
    "eapSavingWithoutDataToast": {
        "danger": {
            "title": "Programme d'aide aux employés et à la famille",
            "message": "Veuillez fournir votre numéro de téléphone et le meilleur moment pour vous contacter"
        }
    },
    "allMyChallenges": "Mes défis",
    "invitedChallenges": "Invitations",
    "companyChallenges": "Défis de l'entreprise",
    "completedChallengesEmpty": "On dirait que vous n’avez pas encore relevé de défi.",
    "myChallengesEmpty": "Il semble que vous ne participez pas encore à un défi.",
    "allChallengesEmpty": "Il n'y a pas de défis.",
    "startsToday": "Commence aujourd'hui",
    "startedDaysAgo": "Commencé il y a  %{dayCount} jours",
    "startsInDays": "Commence dans %{dayCount} jours",
    "privacyOn": "Désactivé",
    "privacyOff": "Activé",
    "dashboard": {
        "viewLeaderboard": "Voir le classement",
        "timePeriodProgress": "Vos progrès pour cette période",
        "howToEarn": "Comment gagner des points"
    },
    "privacyChangeConfirmationMessage": "Modifier les paramètres de confidentialité?",
    "privacySettingsTitle": "Confidentialité",
    "privacySettingsDescription": "Vous pouvez contrôler la visibilité de votre photo, nom et profil auprès d'autres utilisateurs.",
    "mainLeaderBoardSettingsTitle": "? Classement général",
    "challengeLeaderBoardSettingsTitle": "?Classement du défi",
    "managePrivacySettingUrlTitle": "Gérer les paramètres de confidentialité",
    "onboardingFamilyPrivacySettingsMessageOn": "Vous êtes visible dans les résultats de recherche des amis et de la famille. Vous pouvez choisir de ne pas apparaître dans les résultats de recherche.",
    "onboardingFamilyPrivacySettingsMessageOff": "Avec vos paramètres de confidentialité, vous n’apparaissez actuellement pas dans les résultats de recherche des amis et de la famille.",
    "challengeInvitationPrivacySettingsMessageOn": "Vous êtes visible dans les résultats de recherche pour les invitations aux défis. Vous pouvez choisir de ne pas apparaître dans les résultats de recherche.",
    "challengeInvitationPrivacySettingsMessageOff": "Avec vos paramètres de confidentialité, vous n’apparaissez actuellement pas dans les résultats de recherche pour les invitations aux défis.",
    "challengeParticipationPrivacySettingsMessageOn": "Vous êtes inscrit en tant que participant à ce défi. Vous pouvez choisir de ne pas apparaître dans la liste des participants de vos défis.",
    "challengeParticipationPrivacySettingsMessageOff": "Avec vos paramètres de confidentialité, vous n’apparaissez actuellement pas dans la liste des participants. ",
    "communityInvitationPrivacySettingsMessageOn": "Vous êtes visible dans les résultats de recherche pour les invitations aux communautés. Vous pouvez choisir de ne pas apparaître dans les résultats de recherche.",
    "communityInvitationPrivacySettingsMessageOff": "Avec vos paramètres de confidentialité, vous n’apparaissez actuellement pas dans les résultats de recherche pour les invitations aux communautés. ",
    "communityParticipationPrivacySettingsMessageOn": "Vous êtes inscrit en tant que membre de cette communauté. Vous pouvez choisir de ne pas apparaître dans la liste des membres de vos communautés.",
    "communityParticipationPrivacySettingsMessageOff": "Avec vos paramètres de confidentialité, vous n’apparaissez actuellement pas dans la liste des membres.",
    "eventInvitationPrivacySettingsMessageOn": "Vous êtes visible dans les résultats de recherche pour les invitations aux événements. Vous pouvez choisir de ne pas apparaître dans les résultats de recherche.",
    "eventInvitationPrivacySettingsMessageOff": "Avec vos paramètres de confidentialité, vous n’apparaissez actuellement pas dans les résultats de recherche pour les invitations aux événements. ",
    "eventParticipationPrivacySettingsMessageOn": "Vous êtes inscrit en tant que participant à cet événement. Vous pouvez choisir de ne pas apparaître dans la liste des participants. ",
    "eventParticipationPrivacySettingsMessageOff": "Avec vos paramètres de confidentialité, vous n’apparaissez actuellement pas dans la liste des participants.",
    "mainLeaderboardPrivacySettingsMessageOn": "Vous apparaissez dans les classements généraux. Vous pouvez choisir de ne pas apparaître, ce qui supprimera votre rang, votre photo et votre nom des classements généraux.",
    "mainLeaderboardPrivacySettingsMessageOff": "Avec vos paramètres de confidentialité, vous n’apparaissez actuellement pas dans les classements généraux. ",
    "challengeLeaderboardPrivacySettingsMessageOn": "Vous apparaissez dans les classements des défis. Vous pouvez choisir de ne pas apparaître, ce qui supprimera votre rang, votre photo et votre nom des classements des défis.",
    "challengeLeaderboardPrivacySettingsMessageOff": "Avec vos paramètres de confidentialité, vous n’apparaissez actuellement pas dans les classements des défis. ",
    "thumbsUpConfirmationTitle": "J'aime ",
    "thumbsUpConfirmationDescriptionline1": "Félicitations, vous êtes sur le point de partager votre première mention j’aime et d’encourager les autres!",
    "thumbsUpConfirmationDescriptionline2": "Vous serez inclus dans la liste des personnes qui ont aimé cette publication et votre photo, votre nom et votre profil seront visibles.  ",
    "thumbsUpConfirmationButtonOk": "J'aime ",
    "commentToActionInfoTitle": "Qu'est-ce que les autres voient?",
    "commentToActionMessage": "Lorsque vous commentez, les utilisateurs peuvent voir votre photo, votre nom et votre profil.",
    "postToActionTitle": "Qui peut voir cette publication?",
    "postToActionMessageLine1": "Lorsque vous créez une publication, vous pouvez contrôler qui peut la voir et même la partager seulement avec vous-même.",
    "postToActionMessageLine2": "Sur les publications que vous partagez, votre photo, votre nom et votre profil sont visibles",
    "privateUsersDescriptionChallenge": "Ces participant(s) ont choisi de ne pas apparaître dans la liste",
    "privateUsersFirstNamePlaceHolderChallenge": "%{n} privé",
    "privateUsersLastNamePlaceHolderChallenge": "participant(s)",
    "privateUsersDescriptionEvent": "Ces participant(s) ont choisi de ne pas apparaître dans la liste",
    "privateUsersFirstNamePlaceHolderEvent": "%{n} privé",
    "privateUsersLastNamePlaceHolderEvent": "participant(s)",
    "privateUsersDescriptionCommunity": "Ces membre(s) ont choisi de ne pas apparaître dans la liste",
    "privateUsersFirstNamePlaceHolderCommunity": "%{n} privé",
    "privateUsersLastNamePlaceHolderCommunity": "membre(s)",
    "noPrivacySettings": "Aucun paramètre de confidentialité",
    "linkToPartnerNameWebsite": "Lien via le site web de %{partner_name}",
    "linkToPartnerWebsiteUrl": "URL du site du partenire",
    "start_end_time": "Heure de début et de fin:",
    "joinCreateTeamPrivacyDisclaimer": "Votre photo, votre nom et votre profil seront toujours visibles par ceux qui consultent votre équipe dans un défi, même si vous avez défini vos paramètres de confidentialité sur Privé.",
    "carouselInstructions": {
        "swipe": "Faites glisser les vignettes pour voir tous vos objectifs et défis.",
        "click": "Cliquez sur les vignettes pour voir tous vos objectifs et défis."
    },
    "achieved": "Atteint",
    "hours": "heures",
    "createCommunityFlow": {
        "navigatorTitle": "Créer une communauté ",
        "stepType": {
            "title": "Visibilité de la communauté",
            "subTitle": "Qui pourra voir et rejoindre la communauté ?",
            "privateName": "Privé",
            "publicName": "Publique",
            "privateDescription": "Seules les personnes que vous invitez pourront voir ou rejoindre la communauté",
            "publicDescription": "Tout le monde peut voir et rejoindre cette communauté"
        },
        "stepName": {
            "title": "Nommez votre communauté",
            "subTitle": "Donnez un nom à votre communauté qui indique de quoi il s’agit.",
            "namePlaceholder": "Nom de la communauté",
            "noFieldsTitle": "Nom",
            "noFieldsMessage": "Aucun nom "
        },
        "stepDescription": {
            "title": "A propos de votre communauté",
            "subTitle": "Partagez la raison d’être de votre communauté. ",
            "descriptionPlaceholder": "Description (facultatif)",
            "noFieldsTitle": "Description ",
            "noFieldsMessage": "Pas de description"
        },
        "stepImage": {
            "uploadPhotoButtonTitle": "Ajouter une photo"
        },
        "stepJoin": {
            "title": "Nous avons trouvé des communautés similaires",
            "subTitle": "Souhaitez-vous plutôt rejoindre l'une de ces communautés?"
        },
        "createNew": "Créer une nouvelle communauté"
    },
    "challengeCard": {
        "allActivities": "Toutes les activités dans la",
        "category": "catégorie"
    },
    "myLinkedPartners": "Mes partenaires liés",
    "leaderboardPosition": "Position dans le classement général",
    "remainingInChallenge": "restant(s) au défi ",
    "todays_progress": "Progrès d’aujourd’hui",
    "this_weeks_progress": "Les progrès de cette semaine",
    "this_months_progress": "Les progrès de ce mois",
    "achievement": "médaille",
    "challengeCardHeader": {
        "challenge": "Défi",
        "recommended_personal_goals": "Objectif personnel recommandé",
        "personal_goal": "Objectif personnel",
        "competition": "Compétition",
        "recommended_goals": "Objectif recommandé",
        "team_competition": "Compétition par équipe",
        "team": "Équipe"
    },
    "MyMedibank": "My Medibank",
    "Google": "Google",
    "Facebook": "Facebook",
    "errorEntityTimeMessage": "L'heure de fin ne peut pas être antérieure à l'heure de début",
    "company": "Entreprise",
    "lessThan1DayRemain": "moins d'un jour",
    "lessThan1HourRemain": "moins d'une heure",
    "remainingToday": "restant aujourd'hui",
    "periodEndsDateAndTime": "La période se termine %{date}, %{time}",
    "moreToGo": "%{n} plus %{unit} pour aller de",
    "reachedYourGoal": "Vous avez atteint votre objectif cette %{period}!",
    "reachedYourGoalToday": "Vous avez atteint votre objectif aujourd'hui!",
    "editProfileItemCorrectRange": "Veuillez fournir une valeur %{itemName} valide entre la valeur minimale %{min} et la valeur maximale %{max}.",
    "invalidUrl": "URL invalide",
    "activityLogChanged": {
        "success": "Les modifications apportées à l'activité ont été enregistrées",
        "info": "Une erreur s'est produite. Veuillez réessayer.",
        "danger": "Une erreur s'est produite. Veuillez réessayer."
    },
    "discardAlert": {
        "createChallenge": "Êtes-vous sûr de vouloir supprimer ce %{challengeType}?",
        "inviteByEmail": "Êtes-vous sûr de vouloir annuler les modifications?",
        "createTeam": "Êtes-vous sûr de vouloir annuler la création de cette équipe?",
        "cancel": "Annuler",
        "confirm": "Oui, supprimer"
    },
    "entityInvalidNameError": "Le nom de cet item ne doit contenir que des nombres ou une valeur de chaîne.",
    "accept": "Accepter",
    "sync_now": "Synchroniser maintenant",
    "reconnect_device": "Reconnecter",
    "supported_activities": "Activités admissibles",
    "recentlySynced_activity": "Activité récemment synchronisée",
    "noSyncedActivity_sevenDays": "Aucune activité n’a été synchronisée dans les 7 derniers jours",
    "recentActivityLog": {
        "convertingActivityPoints": "Synchronisation des activités...",
        "activityMinuteOrTwo": "Cela peut prendre une ou deux minutes...",
        "noNewActivities": "Aucune nouvelle activité ajoutée… \nLa synchronisation des nouvelles activités peut prendre jusqu'à une heure."
    },
    "deleteCommunityCheckbox": "Je comprends que cela ne peut pas être annulé",
    "createEvent": {
        "type": {
            "company": "Événement d'entreprise",
            "user": "Événement d'utilisateur",
            "title": "Type d'événement"
        },
        "privacy": "Confidentialité (afficher les participants ou non)",
        "cost": "Coût",
        "associated": {
            "location": "Lieu associé",
            "department": "Département \/ Division associé"
        },
        "maxParticipants": "Max. participants (facultatif)",
        "errorMessage": {
            "limit": "Ne peut être supérieur à %{maxValue}",
            "negative": "Ne peut pas être une valeur négative",
            "selectedLocations": "Veuillez sélectionner un ou plusieurs lieux"
        },
        "selectLocations": "Lieux sélectionnés",
        "createNew": "Créer un nouvel événement"
    },
    "selected": "Sélectionné",
    "deleteEventButton": "Supprimer cet événement",
    "notification": {
        "priorityNotification": {
            "title": "Vous avez des mises à jour importantes non lues",
            "subtitle": "Touchez pour les lire maintenant",
            "subtitleWeb": "Cliquez pour les lire maintenant"
        },
        "sectionTitle": {
            "priorityUnread": "Mises à jour importantes non lues",
            "all": "Toutes les notifications"
        },
        "modalTitle": "Vous avez %{count} mises à jour importantes",
        "priorityModalTitle": {
            "defaultTitle": "Voir toutes les mises à jour"
        }
    },
    "createEntity": {
        "cancel": {
            "title": "Annuler la %{actionType}",
            "message": "Êtes-vous sûr de vouloir annuler la %{actionType} cet item?"
        },
        "action": {
            "creating": "création",
            "editing": "modification"
        },
        "type": {
            "team": "équipe",
            "community": "communauté",
            "event": "événement",
            "challenge": "défi",
            "goal": "objectif"
        }
    },
    "publicVisibilitySwitch": {
        "modalTitle": {
            "public": "Le rendre public?",
            "private": "Le rendre privé?"
        },
        "modalSubtitle": {
            "public": "Rendre ceci public veut dire que tout le monde pourra le trouver et le rejoindre. Êtes-vous sûr de vouloir rendre ceci public?",
            "private": "Rendre cet item privé veut dire que personne ne pourra le trouver et le rejoindre. Êtes-vous sûr de vouloir le rendre privé?"
        },
        "footerButton": {
            "makePublic": "Oui, le rendre public",
            "makePrivate": "Oui, le rendre privé",
            "keepPrivate": "Garder privé",
            "keepPublic": "Garder public"
        },
        "label": {
            "title": "Rendre public",
            "subtitle": "Tout le monde peut voir et tout le monde peut rejoindre"
        }
    },
    "imageUploader": {
        "changeImageButton": "Changer l'image"
    },
    "copyright": "Droits d'auteur © Sprout 2019",
    "samsunghealth_not_available": "Impossible de se connecter avec Samsung Health. Dans l'application, sous Autorisations des données, assurez-vous que les autorisations sont activées pour les pas et que vous avez effectué le suivi d’au moins un pas.",
    "rewardsHowDoIEarn": "Comment obtenir des %{currencyName}?",
    "unlockAchievements": "Débloquer des médailles",
    "unlockAchievementsDescription": "Effectuez le suivi d’activités, obtenez des %{pointsName}, débloquez des niveaux et obtenez plus de %{currencyName}. Touchez chaque médaille pour voir ce que vous devez faire.",
    "myDay": "Ma journée",
    "myGoalsChallengesTasks": "Mes objectifs, défis et tâches",
    "yourGoalsChallenges": "Mes objectifs et défis",
    "mySocialStream": "Publications de la communauté",
    "viewAllAchievements": "Voir toutes les médailles ",
    "viewAllBonusChallenges": "Voir tous les défis bonus",
    "newVersionOfAppAvailable": "Nouvelle version disponible! Veuillez recharger cette page",
    "noBonusChallengesToDisplay": "Il n'y a actuellement aucun défi bonus disponible.",
    "bonusChallenges": "Défis bonus",
    "reloadAppVersion": "Recharger",
    "appname": "Sprout",
    "cancel_tracking_confirmation": "Êtes-vous sûr de vouloir supprimer le suivi de %{activité_nom}?",
    "activity_tracker_instruction_header": "Choisissez une journée pour ajouter les activités de cette journée ou voir ce qui a déjà été ajouté.",
    "alertDashboardFunctionalityToBeAdded": "du texte sera ajouté ici pour expliquer ce qu'est une période de suivi. Elle fonctionne comme les programmes de fidélité proposés par les compagnies aériennes: les utilisateurs cumulent des \"miles\" au cours d'une année civile pour obtenir un statut l'année suivante.",
    "noNumberEntered": "Saisir le nombre d'activités",
    "feed": "Fil d’actualité",
    "home": "Accueil",
    "challenges": "Défis",
    "explore": "Découvrir",
    "rewards": "Récompenses",
    "reward": "récompense",
    "balance": "Mon solde de récompenses du programme %{programName}",
    "profile": "Profil",
    "loading": "Chargement...",
    "me": "Moi",
    "back": "Précédent",
    "next": "Suivant",
    "skip": "Ignorer",
    "signup": "S'inscrire",
    "signin": "Se connecter",
    "signin_maintitle": "Sprout",
    "signin_subtitle": "",
    "signinto": "Se connecter à Live Better",
    "signup_with_medibank": "S'inscrire avec My Medibank",
    "signup_with_facebook": "S'inscrire avec Facebook",
    "signup_with_google": "S'inscrire avec Google",
    "signup_with_email": "S'inscrire avec une adresse de courriel",
    "signin_with_medibank": "Se connecter avec My Medibank",
    "signin_with_facebook": "Se connecter avec Facebook",
    "signin_with_google": "Se connecter avec Google",
    "signin_with_email": "Se connecter avec une adresse de courriel",
    "signup_heading": "Créer un compte",
    "not_a_medibank_member": "Vous n’êtes pas membre de Medibank?",
    "keep_me_signed_in": "Garder ma session active",
    "forgotpassword": "Mot de passe oublié?",
    "emailaddress": "Adresse de courriel",
    "password": "Mot de passe",
    "enterEmailAddress": "Saisir votre adresse de courriel",
    "enterYourPassword": "Saisir votre mot de passe",
    "password_for_error": "mot de passe",
    "reset_password": "Réinitialiser le mot de passe",
    "passwordResetSuccess": "Réinitialisation du mot de passe",
    "passwordResetEmailSent": "Si nous avons une address courriel correspondante dans notre système, alors les instructions de réinitialisation du mot de passe vous ont été envoyées par courriel",
    "loginerror": "Une erreur est survenue lors de la connexion:",
    "logincancelled": "Connexion annulée",
    "part_of_corporate_program": "Est-ce que vous vous inscrivez à un programme d'entreprise?",
    "continue_here": "Continuer ici",
    "program_name": "Nom du programme",
    "error_provide_program_name": "Indiquez le nom du programme.",
    "program_not_found": "Programme introuvable",
    "registration_field_email": "Courriel",
    "employeeId": "ID de l'employé",
    "registration_field_firstName": "Prénom",
    "registration_field_lastName": "Nom",
    "no_first_name": "Aucun prénom",
    "no_last_name": "Aucun nom",
    "registration_field_password": "Nouveau mot de passe",
    "no_disclaimer_available": "Oups! Un problème est survenu… impossible de récupérer les conditions générales de votre organisation. Réessayez de vous inscrire ultérieurement.",
    "registration_account_not_registered": "On dirait que vous n'avez pas encore confirmé votre adresse de courriel. Voulez-vous recevoir le courriel à nouveau?",
    "resend_verification_email": "Confirmation du courriel",
    "resend_verification_email_successful": "Nous avons renvoyé votre courriel de confirmation.",
    "resend_verification_email_unsuccessful": "Oups! Un problème est survenu… impossible de renvoyer le courriel de confirmation. Veuillez réessayer.",
    "not_supported": "Cette publication ne peut pas être affichée pour le moment. Réessayez ultérieurement.",
    "policyAgreeError": "Pour continuer, veuillez accepter les conditions d'utilisation et la politique de confidentialité.",
    "challenge_completion_bonus": "Bonus d'accomplissement",
    "me_tabs": {
        "activity": "Activité",
        "bookmarks": "Signets"
    },
    "health_tab": {
        "my_health_score": "Votre score santé",
        "overall_health_score_description": "Votre score santé est",
        "health_score_explanation": "Votre score est mis à jour tous les mois en fonction de vos niveaux d'activité.\n\nVous pouvez fixer et atteindre des objectifs personnels afin d'améliorer votre score santé.",
        "health_score_calculation_failed_onboarding": "Une erreur est survenue et nous n'avons pas pu récupérer votre score santé. Vous pouvez continuer pour le moment : nous mettrons à jour votre score dès que le problème sera résolu."
    },
    "track_activity": "Ajouter des activités",
    "track_an_activity": "Ajouter une activité ",
    "track": "Ajouter",
    "unable_to_track": "Suivi impossible",
    "enter_before_track": "Saisir le nombre d'activités à ajouter",
    "what_to_share": "Quel genre de publication souhaitez-vous partager?",
    "remove": "Supprimer",
    "activity_tracking_description": "Combien de %{units} souhaitez-vous suivre?",
    "excessive_submission": "Waouh! Vous êtes sur le point de suivre plus de 2 000 %{customPoints} pour l'activité %{activity_name}. Vérifiez ces renseignements avant de valider.",
    "on": "le",
    "in": "po",
    "from": "du",
    "at": "à",
    "no_activities": "Aucune activité ne correspond à votre recherche.",
    "activity_tracking_desc": "Vous devez ajouter un nombre pour continuer. Touchez le X dans le coin supérieur gauche pour annuler.",
    "activity_tracking_desc2": "Touchez n'importe où sur l'activité pour modifier les renseignements et touchez + pour rapidement suivre l'objectif",
    "vital_stats_title": "Votre profil",
    "invalid_numeric_response": "Non valide",
    "invalid_numeric_response_range": "Ce nombre doit être compris entre %{minimum} et %{maximum}",
    "search_placeholder": "Rechercher dans la bibliothèque...",
    "search_activities": "Rechercher des activités",
    "searching": "Recherche...",
    "searchEmpty": "Aucun résultat trouvé",
    "vital_stats_description": "Parlez-nous un peu de vous",
    "health_survey_questions": "Questions du questionnaire santé",
    "health_survey_title": "Remplir le questionnaire santé",
    "health_survey_results": "Résultats du questionnaire santé",
    "health_survey_card_desc": "Répondez au questionnaire pour obtenir une vue d'ensemble de votre bien-être et pour fixer des objectifs personnalisés.",
    "apps_devices_title": "Lier des applications et des appareils\n",
    "apps_devices_card_desc": "Grâce à la synchronisation de vos applications et de vos appareils, gagner des %{customPoints} devient un jeu d'enfant.",
    "interests_title": "Centres d'intérêt",
    "interests_card_desc": "Parlez-nous de vos centres d'intérêt. Nous pourrons ainsi vous recommander plus facilement des objectifs et des communautés qui sont susceptibles de vous intéresser.",
    "interests_screen_desc": "Répondez au questionnaire pour obtenir une vue d'ensemble de votre bien-être et pour fixer des objectifs personnalisés.",
    "health_obj_title": "Objectifs de bien-être",
    "health_obj_card_desc": "Il est temps de fixer des objectifs. Dès que nous connaîtrons vos objectifs, nous pourrons améliorer nos recommandations. Ne vous inquiétez pas, si vous changez d'avis, vous pouvez facilement modifier votre profil ultérieurement.",
    "health_obj_screen_desc": "Quels sont vos objectifs de bien-être?",
    "my_heatlh_obj": "Mes objectifs de bien-être",
    "health_topic_title": "Thèmes de bien-être",
    "health_topic_card_desc": "Personnalisez votre expérience en indiquant les sujets de bien-être qui vous intéressent.",
    "health_topic_screen_desc": "Quels sont les sujets sur lesquels vous souhaiteriez vous informer?",
    "multi_select_check_error": "Sélectionnez au moins une option pour continuer",
    "my_health_topics": "Mes sujets bien-être",
    "build_your_profile": "Créez votre profil",
    "personalize_title": "Personnaliser",
    "personalize_desc": "Personnalisez votre expérience en répondant à quelques questions rapides.",
    "set_goals_title": "Afficher les objectifs recommandés",
    "set_goals_desc": "Fixez des objectifs personnalisés pour commencer à être plus en forme.",
    "set_this_goal": "Fixer cet objectif ",
    "goal_set": "Objectif fixé ",
    "required": "Obligatoire",
    "apps_devices_description": "Connectez-vous à une plateforme de fitness pour gagner plus de %{customPoints} automatiquement.",
    "connected": "Connecté",
    "num_connected": "(%{numDevices} connectés)",
    "available": "Disponible",
    "inProgress": "En cours...",
    "time_a_m": "du matin",
    "time_p_m": "de l'après-midi",
    "last_synced": "Dernière synchronisation",
    "last_synced_lc": "dernière synchronisation",
    "no_connected_devices": "Aucun appareil connecté",
    "apps_devices_confirm_disconnect": "Voulez-vous vraiment vous déconnecter?",
    "button_delete": "Supprimer",
    "button_disconnect": "Déconnecter",
    "button_cancel": "Annuler",
    "button_dismiss": "Ignorer",
    "ok": "OK",
    "waist_helper_text": "Mesurez votre tour de taille entre vos côtes et votre nombril. En cas de doute, vous pouvez utiliser la taille de vos jeans.",
    "apps_devices_manage": "Gérer mes applications et appareils",
    "my_apps_devices": "Mes applications et appareils",
    "completeRegistration": "Terminer l'inscription",
    "havingTrouble": "Vous rencontrez des difficultés?",
    "contactUs": "Envoyez un courriel à l'adresse support@sproutatwork.com pour obtenir de l'aide",
    "done": "Terminé",
    "brand": "Sprout",
    "cannotTrackTitle": "Impossible d’ajouter l'activité",
    "cannotTrackPrior": "Pas si vite. Les activités peuvent seulement être ajoutées après la date de début.",
    "cannotTrackFuture": "Pas si vite. Les activités peuvent seulement être ajoutées jusqu'à la journée en cours.",
    "cannotTrack": "Les activités ne peuvent pas être ajoutées avant la date de début ou pour un jour ultérieur.",
    "disclaimer": "Avertissement",
    "acceptTerms": "J'accepte les conditions générales",
    "verificationEmailTitle": "Confirmez votre courriel ",
    "email_not_yet_verified": "On dirait que vous n'avez pas encore confirmé votre adresse de courriel.",
    "email_successfully_verified_title": "Bienvenue",
    "email_successfully_verified": "Vous avez confirmé votre adresse de courriel",
    "pleaseVerifyEmailMessage1": "Vous devez confirmer votre adresse de courriel avant de continuer.",
    "pleaseVerifyEmailMessage2": "Suivez les instructions envoyées à l'adresse :",
    "supportEmail": "support@sproutatwork.com",
    "resendEmail": "Renvoyer le courriel",
    "restart": "Retour à la page de connexion",
    "firstName": "Prénom",
    "firstNamePlaceholder": "Votre prénom",
    "lastName": "Nom",
    "lastNamePlaceholder": "Votre nom",
    "email": "Courriel",
    "emailPlaceholder": "Votre adresse de courriel",
    "employeId": "ID de l'employé",
    "employeIdPlaceholder": "ID de l'employé de l'entreprise",
    "passwordPlaceholder": "Nouveau mot de passe",
    "datePickerTitle": "Sélectionner votre date de naissance",
    "datePickerConfirm": "Confirmer",
    "datePickerCancel": "Annuler",
    "termsOfUsePrivacyPreLinks": "J'accepte les",
    "sendMePromoCommunications": "M'envoyer des communications promotionnelles",
    "sendMePromoCommunicationsFromPartners": "M'envoyer des communications promotionnelles de partenaires",
    "termsOfService": "Conditions d'utilisation",
    "legal": "Mentions légales",
    "privacyPolicy": "Politique de confidentialité",
    "and": "et la",
    "programDomainLabel": "Nom du programme",
    "programDomainPlaceholder": "Nom du programme",
    "findProgramName": "Trouver le nom de mon programme",
    "findProgramNameButton": "Trouver le nom d'un programme",
    "findProgramNameTitle": "Trouver le nom de mon programme",
    "findProgramNameDescription": "Adresse de courriel d'entreprise",
    "findProgramNamePlaceholder": "Adresse de courriel",
    "findProgramSuccessMessage": "Les résultats de la recherche pour le nom de programme vous ont été envoyés par courriel.",
    "findProgramSuccessTitle": "Nom du programme",
    "findProgramErrorTitle": "Nom du programme",
    "findProgramErrorMessage": "Oups! Un problème est survenu… une erreur s'est produite lors de la tentative de récupération du nom de votre programme. Veuillez réssayer.",
    "countryLabel": "Sélectionner un pays",
    "countryName": "Pays",
    "regionLabel": "Sélectionner une région",
    "regionName": "Région",
    "cityLabel": "Sélectionner une ville",
    "cityName": "Ville",
    "locationWorkLabel": "Sélectionner un lieu",
    "locationWorkName": "Lieu",
    "locationLabel": "Sélectionner un lieu",
    "locationName": "Lieu",
    "departmentLabel": "Sélectionner un service \/ division",
    "departmentName": "Service \/ division",
    "no_department": "Aucun service \/ division",
    "enterPIN": "Saisissez le numéro d'identification de programme (NIP) de votre entreprise",
    "verifyEmailTitle": "Confirmation du courriel",
    "verifyEmailMsg": "On dirait que vous n'avez pas encore confirmé votre adresse de courriel",
    "resendEmailTitle": "Confirmation du courriel",
    "resendEmailMsg": "Renvoyé à l'adresse %{userEmail}",
    "select_date": "Sélectionner une date",
    "changePasswordTitle": "Modifier le mot de passe",
    "currentPassword": "Mot de passe actuel",
    "newPassword": "Nouveau mot de passe",
    "confirmNewPassword": "Confirmer le nouveau mot de passe",
    "passwordChangeError": {
        "currentPasswordMissing": "Saisir votre mot de passe actuel",
        "newPasswordMissing": "Saisir votre nouveau mot de passe",
        "confirmPasswordMissing": "Confirmer votre nouveau mot de passe",
        "passwordsMatch": "Les mots de passe ne correspondent pas",
        "passwordIncorrect": "Mot de passe incorrect. Veuillez réessayer."
    },
    "settings": "Paramètres",
    "signOut": "Se déconnecter",
    "updateApp": "Mettre à jour l'appli",
    "updateAppRight": "V. actuelle: %{version}",
    "appleStoreUrlSprout": "https:\/\/itunes.apple.com\/us\/app\/sprout-at-work\/id904741273",
    "playStoreUrlSprout": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.sproutmobileapp",
    "appleStoreUrlLiveBetter": "https:\/\/itunes.apple.com\/us\/app\/live-better\/id1289314646",
    "playStoreUrlLiveBetter": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.livebetter",
    "appleStoreUrlTelus": "https:\/\/apps.apple.com\/app\/telus-health-wellbeing\/id1627569346",
    "playStoreUrlTelus": "https:\/\/play.google.com\/store\/apps\/details?id=com.telus.health.wellbeing",
    "appleStoreUrlUPnGO": "https:\/\/itunes.apple.com\/us\/app\/upngo-with-participaction\/id1079958142",
    "playStoreUrlUPnGO": "https:\/\/play.google.com\/store\/apps\/details?id=com.sproutatwork.upngo",
    "getHelp": "Obtenir de l'aide",
    "feedback": "Commentaires",
    "feedback_success_title": "Commentaire envoyé",
    "feedback_success_msg": "Merci d'avoir envoyé votre commentaire. Nous vous en sommes très reconnaissants.",
    "feedback_failure_title": "Erreur",
    "feedback_failure_msg": "Zut… une erreur s'est produite lors de l'envoi de votre commentaire. Veuillez réessayer.",
    "submit": "Envoyer",
    "feedback_char_limit": "Vous avez dépassé la limite de caractères.",
    "feedback_char_limit_toast_title": "Message trop long",
    "feedback_char_limit_toast_msg": "Votre message dépasse la limite maximum de 2 000 caractères.",
    "feedback_char_length_msg_1": "Vous avez saisi",
    "feedback_char_length_msg_2": "\/2 000 caractères.",
    "feedback_empty_toast_title": "Message vide",
    "feedback_empty_toast_msg": "Vous n'avez rien saisi. Tapez votre message avant de l'envoyer.",
    "feedback_email_message": "Message :",
    "feedback_email_user_id": ", ID de l'utilisateur :",
    "feedback_email_device": ", Appareil :",
    "feedback_email_os_version": ", Version du SE :",
    "feedback_email_app_version": ", Version de l'application :",
    "savingUserToast": {
        "success": {
            "title": "Enregistrer les modifications",
            "message": "Modifications de votre profil enregistrées"
        },
        "danger": {
            "title": "Une erreur est survenue",
            "message": "Oups… une erreur s'est produite lors de l'enregistrement de vos modifications. Veuillez réessayer."
        }
    },
    "edit_profile_user_error_msg": "Lisez les messages d'erreur avant d'essayer d'enregistrer vos modifications.",
    "edit_profile_location_error": "Vous devez indiquer votre position",
    "edit_profile_department_error": "Vous devez indiquer votre service \/ division",
    "edit_profile_unspecified_value": "Vous devez indiquer une valeur",
    "edit_profile_value_too_low": "La valeur doit être supérieure à",
    "edit_profile_value_too_high": "La valeur doit être inférieure à",
    "choose_gender": "Choisir le sexe",
    "activity_tracked_successfuly": "Votre activité est ajoutée",
    "multi_activity_tracked_successfully": "Vos activités sont ajoutées",
    "no_activities_tracked": "Aucune activité ajoutée",
    "track_activity_to_submit": "Sélectionner une date sur le calendrier pour ajouter une activité",
    "last_day": "Dernier",
    "days_remaining": "jours restants",
    "day_remaining": "jour restant",
    "days_remaining_this_week": "jours restants cette semaine",
    "day_remaining_this_week": "jour restant cette semaine",
    "days_remaining_this_month": "jours restants ce mois-ci",
    "day_remaining_this_month": "jour restant ce mois-ci",
    "earned_today": "Obtenus aujourd'hui",
    "earned_this_week": "Obtenus cette semaine",
    "earned_this_month": "Obtenus ce mois-ci",
    "earned_in_total": "Obtenus au total ",
    "goal_completed": "Objectif atteint,",
    "see_results": "voir les résultats",
    "pts": "%{customPoints}",
    "of": "de",
    "daily_goal": "Objectif quotidien",
    "weekly_goal": "Objectif hebdomadaire",
    "monthly_goal": "Objectif mensuel",
    "total_goal": "Objectif global",
    "weeks": "semaines",
    "today": "Aujourd'hui",
    "this_week": "Cette semaine",
    "this_month": "Ce mois-ci",
    "overall": "Global",
    "level": "Niveau",
    "days_remaining_in_period": "%{remainingDays} jours restants",
    "days_left_in_period": "%{remainingDays} jours restants pour faire le suivi",
    "pointsToLevel": "Progrès vers %{levelName}",
    "levelCompleted": "%{levelName} terminé",
    "keepTrackingUntil": "Continuer à suivre jusqu'au",
    "activityLevelTitle": "Mon niveau d'activité",
    "activityLevelDescription": "Lors d'une semaine normale, durant combien de temps êtes-vous au moins modérément actif (lorsque vous faites un effort suffisamment intense pour augmenter votre fréquence cardiaque et transpirer)?",
    "activityLevelUnder60": "Moins de 60 minutes",
    "activityLevelUnder150": "60 à 150 minutes",
    "activityLevelOver150": "Plus de 150 minutes",
    "gender_male": "Homme",
    "gender_female": "Femme",
    "gender_rather_not_say": "Je ne souhaite pas répondre",
    "date_of_birth": "Date de naissance",
    "height": "Taille",
    "Height": "Taille",
    "weight": "Poids",
    "waistCircumference": "Tour de taille",
    "bloodPressureHg": "Pression artérielle systolique",
    "bloodPressureMm": "Pression artérielle diastolique",
    "bloodCholesterol": "Taux de cholestérol total dans le sang",
    "ldl": "Lipoprotéine de basse densité (LDL)",
    "hdl": "Lipoprotéine de haute densité (HDL)",
    "restingHeartRate": "Fréquence cardiaque au repos",
    "percentageBodyFat": "Pourcentage de graisse",
    "hipCircumference": "Tour de hanches",
    "bloodGlucose": "Glycémie",
    "triglycerides": "Triglycérides",
    "error_401_signed_out_message": "Votre session a expiré. Reconnectez-vous.",
    "first_name": "Prénom",
    "last_name": "Nom",
    "preferred_name": "Nom préféré",
    "notifications": "Notifications",
    "notificationsMarkAllReadButton": "Marquer toutes les notifications comme lues",
    "notificationsSettingsButton": "Paramètres",
    "notificationsSettingsTitle": "Notifications et courriels",
    "notificationEmptyMessage": "Vous avez consulté toutes vos notifications",
    "priorityModalTitle": "Mes notifications prioritaires",
    "remindMeLater": "Me le rappeler ultérieurement",
    "priorityAdminTitle": "Notification de votre administrateur",
    "markAsRead": "Marquer comme lu",
    "expand": "Touchez pour développer",
    "collapse": "Touchez pour réduire",
    "takePhoto": "Prendre une nouvelle photo",
    "choosePhoto": "Sélectionner une photo",
    "deletePhoto": "Supprimer la photo",
    "profileImageChangeErrorTitle": "Une erreur est survenue",
    "profileImageChangeErrorMessage": "Oups… une erreur s'est produite lors de la modification de votre photo. Veuillez réessayer.",
    "editProfile": "Modifier le profil",
    "postButton": "Publier",
    "shareYourDayName": "Que faites-vous?",
    "greeting": "Bonjour, %{firstNameDisplay}!",
    "shareAnUpdate": "Que faites-vous?",
    "shareYourDaySubtitle": "Que faites-vous?",
    "shareAPost": "Partager une publication",
    "postVisibleTo": "Visible par",
    "link": "Lien",
    "photo": "Photo",
    "insertLink": "Ajouter un lien à votre publication",
    "save": "Enregistrer",
    "sampleLink": "http:\/\/sample.com",
    "shareErrorText": "Vous devez ajouter du contenu à votre publication avant de l'envoyer.",
    "generalErrorTitle": "Publication vide",
    "generalSuccessTitle": "Opération réussie",
    "simplePlaceholder": "Que faites-vous?",
    "likesCountLabel": "Mentions J'aime",
    "likesReceivedLabel": "Mention j'aime reçue",
    "commentsCountLabel": "Commentaires",
    "commentsCountLabelSingular": "Commentaire",
    "likeButton": "J'aime",
    "commentButton": "Commentaire",
    "seePreviousComments": "Afficher les commentaires précédents",
    "addCommentPlaceholder": "Ajouter un commentaire",
    "postCommentButton": "Publier",
    "seeMoreLongComment": "Afficher plus",
    "activityPoints": "%{customPoints}",
    "activityLog": "Journal d'activités",
    "discardPost": "Abandonner",
    "discardPostMessage": "Voulez-vous vraiment abandonner votre publication?",
    "stream_filter_title": "Fil d'actualité ",
    "stream_filter_screen_desc": "Sélectionnez les publications que vous souhaitez voir dans le fil d’actualité",
    "stream_filter_selection": "Affiché :",
    "moderate": "Marquer comme inapproprié",
    "moderateDescription": "Les éléments marqués comme inappropriés seront supprimés. Un administrateur en sera informé.",
    "editPost": "Modifier la publication",
    "deletePost": "Supprimer la publication",
    "deleteComment": "Supprimer le commentaire",
    "editComment": "Modifier le commentaire",
    "visibleOnlyToMe": "Visible par moi seulement",
    "joinEvent": "Répondre à l'événement",
    "joinEventDetail": "Participer à l'événement",
    "joinedEvent": "Je participe",
    "joiningEventToast": {
        "success": {
            "title": "%{eventName}",
            "messageName": "Vous participez à l'événement",
            "message": "Vous avez bien confirmé votre participation à l'événement"
        }
    },
    "joinChallenge": "Relever le défi",
    "viewChallenge": "Afficher le défi",
    "joinedChallenge": "Défi relevé",
    "joinCommunity": "Rejoindre la communauté",
    "joinedCommunity": "Participation confirmée",
    "joinProgress": "Connexion",
    "joinSuccess": "Membre",
    "invitePeopleToCommunity": "Inviter des personnes à rejoindre la communauté",
    "numberOfMembers": "%{num} membres",
    "joinToView": "Rejoindre cette communauté pour consulter les publications des autres membres et publier du contenu",
    "numberOfAttendees": "%{num} participants",
    "numberOfParticipants": "%{num} participants",
    "numberOfMembersWithUser": "Vous et %{num} autres membre(s)",
    "numberOfAttendeesWithUser": "Vous et %{num} autres participant(s)",
    "numberOfParticipantsWithUser": "Vous et %{num} autres participant(s)",
    "communityMembers": "%{numberOfMembers} membre(s)",
    "communityEvents": "%{numberOfEvents} événement(s) à venir",
    "myEvents": "Mes événements",
    "seeAll": "Tout afficher",
    "noUpcomingEvents": "Aucun événement à venir. Participez à un événement.",
    "myCommunities": "Mes communautés",
    "invitedCommunities": "Invitations",
    "invitationSendingMessage": "Envoi des invitations…",
    "invitationReceivedMessage": "vous a invité à rejoindre",
    "invitationMessage": "Nous serions ravis de vous accueillir dans notre communauté.",
    "recommendedCommunities": "Recommandations personnalisées",
    "leaveCommunity": "Quitter cette communauté",
    "leaveTeam": "Voulez-vous vraiment quitter l'équipe",
    "leaveTeamLastMember": "de ce défi? Vous êtes le dernier membre. Par conséquent, votre départ de ce défi supprimera l'équipe.",
    "leaveTeamChallenge": "de ce défi?",
    "Oops": "Oups, une erreur s'est produite",
    "editCommunity": "Modifier la communauté",
    "deleteCommunity": "Supprimer cette communauté",
    "leaveCommunityDescription": "Voulez-vous vraiment quitter cette communauté?",
    "inviteToCommunity": "Inviter à rejoindre la communauté",
    "inviteByMembers": "Inviter par nom",
    "inviteByEmail": "Inviter par courriel",
    "select_person": "Sélectionner au moins une personne à inviter",
    "no_users_found": "Impossible de trouver une personne avec ce nom.",
    "promptJoinCommunities": "Vous n'avez pas encore rejoint de communauté. Rejoignez des communautés pour échanger avec d'autres personnes et partager votre expérience.",
    "exploreCommunities": "Découvrir les communautés",
    "sendInviteByMembers": "Inviter %{num} personne(s)",
    "sendInviteByEmail": "Envoyer une invitation par courriel",
    "createNewCommunity": "Créer une nouvelle communauté",
    "createCommunity": "Créer une communauté",
    "uploadCover": "Ajouter une photo",
    "cover": "Couverture",
    "nameOfCommunity": "Nom de la communauté",
    "whatCommunityAbout": "Quel est l'objectif de cette communauté?",
    "companyMembersOnly": "Membres de l'entreprise seulement",
    "viewAllButton": "Tout afficher",
    "communities": "Communautés",
    "contentLibrary": "Bibliothèque",
    "events": "Événements",
    "past_events": "Événements passés",
    "invitationCommunity": "communauté",
    "searchPeople": "Rechercher des personnes",
    "enterEmail": "Saisir le courriel",
    "personalMessageToNewInvitees": "Message personnel envoyé aux nouveaux invités",
    "dangerToastTitle": "Erreur",
    "dangerToastMessage": "Une erreur s'est produite. Veuillez réessayer.",
    "successToastTitle": "Opération réussie",
    "successToastMessage": "Action terminée",
    "joiningToast": {
        "success": {
            "message": "Vous avez rejoint"
        }
    },
    "deletingCommentToast": {
        "success": {
            "message": "Commentaire supprimé"
        }
    },
    "moderatingCommentToast": {
        "success": {
            "message": "Commentaire marqué comme inapproprié"
        }
    },
    "editingCommentToast": {
        "success": {
            "message": "Commentaire mis à jour"
        }
    },
    "gettingLikesToast": {
        "success": {
            "message": "Commentaire mis à jour"
        }
    },
    "updatingAvatarToast": {
        "success": {
            "message": "Photo mise à jour"
        }
    },
    "deletingAvatarAvatarToast": {
        "success": {
            "message": "Photo supprimée"
        }
    },
    "creatingStreamToast": {
        "success": {
            "title": "Publier sur le fil d’actualité",
            "message": "Votre publication a été créée"
        }
    },
    "editingStreamToast": {
        "success": {
            "title": "Modifier la publication",
            "message": "Votre publication a été modifiée"
        }
    },
    "deletingPostToast": {
        "success": {
            "title": "Supprimer la publication",
            "message": "Votre publication a été supprimée"
        }
    },
    "moderatingPostToast": {
        "success": {
            "title": "Marquer comme inapproprié",
            "message": "Publication marquée comme inappropriée"
        }
    },
    "markingAllNotificationsToast": {
        "success": {
            "title": "Marquer comme lu",
            "message": "Toutes les notifications ont été marquées comme lues"
        },
        "info": {
            "title": "Marquer comme lu",
            "message": "Toutes les notifications ont déjà été marquées comme lues."
        },
        "danger": {
            "title": "Marquer comme lu"
        }
    },
    "markingNotificationToast": {
        "danger": {
            "title": "Impossible de marquer la notification comme lue"
        }
    },
    "changePasswordToast": {
        "success": {
            "title": "Mot de passe mis à jour",
            "message": "Connectez-vous avec votre nouveau mot de passe"
        },
        "danger": {
            "title": "Mettre à jour le mot de passe",
            "message": "Oups… une erreur s'est produite lors de la mise à jour de votre mot de passe. Veuillez réessayer. "
        }
    },
    "joining": {
        "success": {
            "message": "Vous avez rejoint %{name}"
        }
    },
    "invitingUsersToast": {
        "success": {
            "title": "Invitations",
            "message": "Les invitations ont été envoyées"
        }
    },
    "creatingCommunityToast": {
        "success": {
            "title": "Créer une communauté",
            "message": "Votre communauté a été créée"
        }
    },
    "restartingCustomGoalToast": {
        "success": {
            "message": "Votre objectif a été relancé"
        },
        "danger": {
            "message": "Impossible de relancer l'objectif"
        }
    },
    "quit": "Quitter",
    "wellbeing_survey_completed": "Questionnaire santé complété ",
    "wellbeing_survey_completed_message": "Merci d'avoir répondu au questionnaire. Nous espérons que ce questionnaire vous a permis de mieux comprendre comment contribuer à votre bien-être.",
    "update_wellbeing_score": "Mettre à jour mes réponses au questionnaire",
    "get_wellbeing_score": "Obtenir votre score santé",
    "stats": "Stats",
    "my_wellbeing_score": "Mon score santé",
    "see_details": "Afficher plus de renseignements",
    "how_score_calculated": "Comment est calculé mon score?",
    "contentTitle": "Bibliothèque",
    "promoted": "En vedette",
    "recommended": "Recommandé",
    "recommendedForMe": "Recommandations personnalisées",
    "recent": "Ajouts récents",
    "view": "Afficher",
    "added": "Date d'ajout",
    "more": "plus",
    "openLibrary": "Accéder à la bibliothèque",
    "readToEarn": "Lire pour gagner",
    "readArticle": "Ouvrir le lien",
    "see_more": "Afficher plus (%{num})",
    "see_more_activities": "%{num} de plus",
    "my_achievements": "Mes médailles",
    "achievements": "Médailles",
    "achievement_earned_date": "Obtenu : %{date}",
    "achievement_start_date": "Début : %{date}",
    "achievement_end_date": "Fin : %{date}",
    "achievement_earned": "Obtenu",
    "achievement_start": "Débute",
    "achievement_end": "Se termine",
    "achievement_earned_times": "%{num} fois",
    "achievement_earned_time": "%{num} fois",
    "in_progress": "En cours",
    "date_earned": "Date d'obtention",
    "earned": "Obtenu",
    "past_dates_earned_heading": "Anciennes dates d'obtention",
    "all": "Tous",
    "eat": "Manger",
    "move": "Bouger",
    "feel": "Ressentir",
    "profile_completion": "Progression du profil : %{percentage}%",
    "complete_my_profile": "Complétez votre profil",
    "do_following_tasks": "Effectuez les %{num} tâches suivantes pour compléter votre profil.",
    "improve_my_score": "Améliorer votre score",
    "see_which_goals": "Consultez les objectifs que vous vous êtes fixés concernant l'alimentation, l'activité physique et le bien-être.",
    "havent_set_goal": "Vous n'avez pas encore fixé d'objectifs.",
    "set_a_goal": "Fixer un objectif",
    "set_another_goal": "Fixer un autre objectif",
    "set_another_goal_here": "Fixez un autre objectif ici.",
    "my_recently_tracked_activities": "Mes activités récentes",
    "a_few_seconds_ago": "il y a quelques secondes",
    "a_day_ago": "il y a un jour",
    "yesterday": "Hier",
    "earn": "Gagnez",
    "delete_activity_confirmation": "Voulez-vous vraiment supprimer cette activité?",
    "delete_activity_title": "Supprimer %{measurement} de %{activity_name}?",
    "reached_daily_goal": "Vous avez atteint votre objectif aujourd’hui. Bien joué! ",
    "multiple_activity_non_daily_instruction": "Touchez une ligne d'activité pour commencer à la suivre et obtenir %{customPoints}!",
    "multiple_activity_daily_instruction": "Touchez le signe + pour faire le suivi de la valeur requise d'une activité pour atteindre votre objectif. Touchez n'importe où sur la ligne de l'activité pour suivre une valeur de cette activité.",
    "only_automatic_activities": "Les activités qui permettent d'atteindre cet objectif peuvent seulement être ajoutées automatiquement",
    "only_automatic_activity": "L'activité qui permet d'atteindre cet objectif peut seulement être ajoutée automatiquement",
    "earn_pts_and_reach_goal": "Gagnez %{pts} pts et atteignez votre objectif en enregistrant %{qty}",
    "earn_pts_for_every": "Gagner %{pts} pts pour chaque",
    "you_track": "ajoutée.",
    "you_have_tracked": "Vous avez enregistré %{qty}",
    "so_far": "jusqu'à présent.",
    "start_goal": "Fixer cet objectif",
    "about_this_goal": "À propos de cet objectif",
    "start_date": "Date de début",
    "end_date": "Date de fin",
    "activities": "Activités",
    "goal": "Objectif",
    "instructions": "Instructions",
    "daily": "tous les jours",
    "weekly": "chaque semaine",
    "monthly": "chaque mois",
    "total": "Total",
    "week": "Semaine",
    "day": "Jour",
    "days": "Jours",
    "month": "Mois",
    "months": "Mois",
    "progress": "Progrès",
    "about": "À propos de",
    "days_remaining_to_track": "Il vous reste %{num} jours pour ajouter les activités manquantes",
    "number_days": "%{num} jour(s)",
    "one_day": "1 jour",
    "points_earned_this_week": "Points gagnés cette semaine",
    "points_earned_year": "Points gagnés depuis le début de l'année",
    "completed": "Défis terminés",
    "what_you_need_to_do": "Actions requises",
    "see_all_num": "Afficher les %{num} éléments",
    "my_week_progress": "Vos progrès hebdomadaires",
    "my_day_progress": "Vos progrès quotidiens",
    "my_month_progress": "Vos progrès mensuels",
    "my_total_progress": "Vos progrès globaux",
    "my_overall_progress": "Ensemble des progrès",
    "you_earned": "Vous avez gagné",
    "of_this_week": "sur %{num} cette semaine",
    "of_this_day": "sur %{num} aujourd'hui",
    "of_this_month": "sur %{num} ce mois-ci",
    "of_this_total": "sur %{num} au total",
    "of_this_overall": "sur %{num} en tout",
    "remaining_this_week": "restant(s) cette semaine",
    "remaining_this_month": "restant(s) ce mois-ci",
    "remaining_this_total": "restant(s)",
    "remaining_this_overall": "restant(s) en tout",
    "view_history": "Afficher l'historique",
    "this_goal_is": "Cet objectif est",
    "will_run_for": "Va durer",
    "button_unset_goal": "Annuler l'objectif",
    "button_leave_challenge": "Quitter le défi",
    "leaveChallenge": {
        "menu": "Quitter %{challengeName}"
    },
    "deleteChallenge": {
        "menu": "Supprimer %{challengeName}"
    },
    "unsetGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Vous avez annulé cet objectif personnel."
        }
    },
    "leaveChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Vous avez quitté le défi."
        }
    },
    "activities_tracked": "Activités ajoutées",
    "recently_tracked_activities": "Activités récemment ajoutées",
    "add": "Ajouter",
    "change_before_track": "Vous n'avez effectué aucune modification. Modifiez le nombre d'activités de cette journée ou quittez la page sans apporter de modifications.",
    "havent_tracked_today": "Vous ne suivez aucune activité pour cette journée. Commencez par rechercher une activité.",
    "cancel_tracking_quantity": "Annuler le suivi de %{quantity} de %{activity_name}",
    "points": "%{customPoints}",
    "discard_activity_edits_confirmation": "Si vous quittez la page, toutes les modifications apportées à l'historique de vos activités seront perdues. Voulez-vous vraiment continuer?",
    "discard_activity_edits_confirmation_date": "Si vous quittez la page, toutes les modifications apportées à l'historique de vos activités pour %{date} seront perdues. Voulez-vous vraiment continuer?",
    "yes_discard_edits": "Oui, quitter et annuler les modifications",
    "createGoal": {
        "navigatorTitle": "Créer un objectif personnel",
        "navigatorSubtitle": "Étape %{step} de 4"
    },
    "allCommunities": "Tout",
    "deleteCommunityDescription": "Voulez-vous vraiment supprimer cette communauté?",
    "remaining": "restant(s)",
    "recommended_goal": "Objectif recommandé",
    "pinError": "Le NIP %{pin} n'est pas valide. Veuillez en essayer un autre.",
    "previousPersonalGoals": "Mes objectifs personnels atteints",
    "previousGoalsTitle": "Mes objectifs précédents",
    "endedOn": "terminé le",
    "achievedOfGoal": "Vous avez atteint %{num}% de l'objectif",
    "previousGoalsEmptyMessage": "Vous ne possédez aucun objectif précédent",
    "emptyListDefaultMessage": "Vous ne possédez aucun élément ici",
    "myCommunitiesEmpty": "Vous n'avez pas encore rejoint de communauté. Rejoignez des communautés pour échanger avec d'autres personnes et partager votre expérience.",
    "discoverMoreCommunities": "Découvrir plus de communautés",
    "howLong": "Durée",
    "frequency": "Fréquence",
    "discard": "Abandonner",
    "description": "Description",
    "optional": "facultatif",
    "instruction": "Instruction",
    "name": "Nom",
    "create": "Créer",
    "categories": "Catégories",
    "uploadPhoto": "Ajouter une photo",
    "delete_goal": "Supprimer %{name}",
    "delete_goal_confirmation": "Voulez-vous vraiment supprimer cet objectif?",
    "leave_goal_confirmation": "Voulez-vous vraiment quitter ce défi?",
    "creatingCustomGoalToast": {
        "success": {
            "message": "Votre objectif a été créé."
        }
    },
    "defaultSelectMessage": "Sélectionnez une option",
    "search": "Rechercher",
    "inTotal": "au total",
    "State": "Territoire\/province",
    "Business unit": "Unité commerciale",
    "Work location": "Lieu de travail",
    "whenStart": "Quand souhaitez-vous commencer?",
    "every": "chaque",
    "acceptChallenge": "Accepter le défi",
    "activity_history_challenge": "Historique des activités du défi",
    "havent_tracked_challenge": "Vous ne suivez aucune activité pour ce défi",
    "earned_lowercase": "obtenu",
    "noone_tracked_yet": "Personne ne suit d'activités pour le moment. Commencez à suivre une activité pour prendre la tête de cette compétition.",
    "you": "Vous",
    "your_team": "Mon équipe",
    "congrats_first_place": "Félicitations, vous occupez la première place! Poursuivez vos efforts.",
    "leader": "Leader",
    "average": "Moyenne",
    "show_leader": "Afficher le leader",
    "show_me": "Afficher ma position",
    "show_my_team": "Afficher mon équipe",
    "leaderboard": "Classement",
    "my_team": "Mon équipe",
    "remaining_to_track": "restant(s) à suivre",
    "avg": "moy.",
    "invite": "Inviter",
    "team_members": "Membres de l'équipe",
    "daysLeft": "Jours restants",
    "regionNameLiveBetter": "Territoire\/province",
    "locationNameLiveBetter": "Lieu de travail",
    "departmentNameLiveBetter": "Unité commerciale",
    "regionLabelLiveBetter": "Sélectionner un territoire ou une province",
    "locationLabelLiveBetter": "Sélectionner un lieu de travail",
    "departmentLabelLiveBetter": "Sélectionner une unité commerciale",
    "companyLocation": "Lieu de travail",
    "no_location": "Aucun lieu",
    "connect": "Connecter",
    "syncing": "Synchronisation",
    "sync": "Synchroniser",
    "havent_tracked_in_a_while": "Aucune activité récemment ajoutée",
    "contact": "Communiquer avec",
    "manage": "Gérer",
    "creator": "Créateur",
    "allow_notifications": "Gérer les notifications",
    "enable_notifications": "Activer les notifications",
    "appload": "Patientez quelques instants pendant la mise à jour de {app_name}…",
    "sendResetEmail": "Envoyer le courriel de réinitialisation",
    "min": "Min.",
    "max": "Max.",
    "error_joining_team": "Impossible de rejoindre l'équipe",
    "cannot_add_to_team": "Oups… une erreur est survenue lors de l'ajout à cette équipe. L'équipe a peut-être atteint le nombre maximum de membres ou n'existe plus. Si une autre erreur se produit, veuillez réessayer.",
    "members_needed": "%{num} membres requis",
    "member_needed": "%{num} membre requis",
    "spots_left": "%{num} places disponibles",
    "join": "Rejoindre",
    "no_teams_create": "Il n'y a actuellement aucune équipe à rejoindre. Pourquoi ne pas en créer une?",
    "number_teams": "%{num} équipes",
    "youLowercase": "vous",
    "joined_challenge_on_team": "Vous avez relevé un défi avec l'équipe %{team_name}.",
    "join_team": "Rejoindre une équipe",
    "former_members": "Anciens membres",
    "letsGo": "C'est parti",
    "invite_to_team": "Inviter à rejoindre l'équipe",
    "connectingDeviceToast": {
        "success": {
            "title": "Connecter une application ou un appareil",
            "message": "Opération réussie. Votre application ou appareil est connecté."
        },
        "danger": {
            "title": "Connecter une application ou un appareil",
            "message": "Oups… un problème est survenu lors de la connexion de ce service. Veuillez réessayer."
        }
    },
    "disconnectingDeviceToast": {
        "success": {
            "title": "Déconnecter une application ou un appareil",
            "message": "Vous avez bien déconnecté %{name}."
        },
        "danger": {
            "title": "Déconnecter une application ou un appareil",
            "message": "Oups… un problème est survenu lors de la déconnexion de %{name}. Veuillez réessayer."
        }
    },
    "leave_entity_question": "Quitter %{name}?",
    "delete_entity_question": "Supprimer %{name}?",
    "leave_team_challenge_confirmation": "Voulez-vous vraiment quitter %{name} pendant ce défi?",
    "leave_last_team_member": "Vous êtes le dernier membre. Par conséquent, votre départ supprimera l'équipe.",
    "oops_msg": "Oups… une erreur s'est produite lors de l'exécution de cette action. Veuillez réessayer.",
    "has_been_created": "Vous avez relevé un défi avec l'équipe %{name}.",
    "specify_team_name": "Indiquez un nom d'équipe",
    "invite_members": "Inviter des membres",
    "upload_photo_no_question": "Ajouter une photo",
    "my_progress": "Mes progrès",
    "rewardsPointsAdditionalInfo": "Gagnez des %{reward_currency} pour chaque niveau atteint pour chaque %{period}. Vos %{customPoints} et niveaux sont remis à zéro chaque %{period} pour vous permettre de continuer à gagner des %{reward_currency}, même si vous avez atteint le niveau le plus élevé la période précédente.",
    "rewardsPointsInfo": "Vos %{customPoints} et progrès se réinitialisent chaque %{period}.",
    "departments": "Services \/ division",
    "regions": "Régions",
    "noItemsSelected": "Aucun élément sélectionné",
    "pleaseSelectOne": "Sélectionnez au moins un élément dans la liste",
    "tracked": "Suivi",
    "starts": "Débute",
    "duration": "Durée",
    "bonus": "Bonus",
    "invited_by": "Invité par",
    "create_team": "Créer une équipe",
    "discardConfirmation": "Voulez-vous vraiment abandonner?",
    "discardYes": "Oui, abandonner",
    "discardStay": "Non, rester ici",
    "create_team_toast_title": "Créer une équipe",
    "edit_team": "Modifier l'équipe",
    "team_edits_submitted": "Votre équipe a bien été mise à jour.",
    "challenge_ended_still_trackable": "Ce %{type} est terminé. Il vous reste néanmoins encore %{num} jours pour ajouter des activités.",
    "tracking_period_ended": "La période de suivi pour ce %{type} est terminée.",
    "unlimited": "Illimité",
    "ends_in": "Se termine dans",
    "challenge_toast": {
        "success": {
            "join": "Opération réussie.",
            "message": "Vous avez bien relevé le défi."
        },
        "danger": {
            "error": "Erreur",
            "message": "Une erreur est survenue. Patientez quelques instants puis essayez de participer à nouveau au défi."
        }
    },
    "members_to_invite": "Membres à inviter",
    "members_to_remove": "Membres à supprimer",
    "myChallenges": "Compétitions",
    "upcoming": "À venir",
    "myPersonalGoals": "Objectifs",
    "companyCompetitions": "Compétitions de l'entreprise",
    "communityCompetitions": "Compétitions de la communauté",
    "edit_your_team": "Modifier votre équipe",
    "emails": "Courriels",
    "CompletedOverall": "Terminé dans l'ensemble",
    "TotalEarned": "Gain total",
    "notify_header": "Je souhaite recevoir une notification :",
    "AdditionalBonus": "Bonus supplémentaire",
    "goalEndedNotification": "Objectif terminé. Continuez à vous surpasser!",
    "compEndedNotification": "Compétition terminée. Continuez à vous surpasser!",
    "congrats_tracking_first": "Félicitations, vous suivez votre première activité!",
    "keep_tracking": "Continuez à suivre votre activité pour atteindre des objectifs et augmenter de niveau.",
    "understanding_tracking": "Comprendre le suivi",
    "cannot_track_this_day": "Vous ne pouvez pas effectuer de suivi ce jour-là.",
    "nothing_tracked_this_day": "Aucune activité n'a pour l'instant été ajoutée ce jour-là.",
    "tracked_something_this_day": "Vous avez suivi quelque chose pour ce jour.",
    "reached_goal_this_day": "Vous avez atteint votre objectif pour ce jour (seulement pour les objectifs quotidiens).",
    "got_it": "OK",
    "notDismissedMultiTitle": "Résumé des défis",
    "notDismissedMultiSubtitle": "Plusieurs défis ont pris fin. Consultez en détail chaque défi pour obtenir vos résultats.",
    "daySummary": "%{userName}, voici un résumé de votre journée jusqu'à présent",
    "goals": "Objectifs",
    "competitions": "Compétitions",
    "totalAccumulated": "Total accumulé",
    "tracking_for_date": "Suivi pour le %{date}",
    "activity_tracker_instruction": "Touchez pour modifier ou supprimer manuellement une activité ajoutée",
    "ended": "Terminé",
    "notYetAvailableBeta": "Pas encore disponible en version bêta",
    "suggestedGoal": "Objectif suggéré",
    "singleFor": "pour",
    "seeLessLongComment": "Afficher moins",
    "synced_data": "Données synchronisées :",
    "doThisLater": "Je le ferai plus tard",
    "inviteUsers": "Inviter à rejoindre",
    "cannotTrackAfterDeadline": "Vous essayez d’ajouter une activité pour une date postérieure à la date limite du défi.",
    "potentialBonusPoints": {
        "section": {
            "title": "%{potentialBonusPoints} %{customPoints} bonus sont disponibles pour ce défi!",
            "titleNotCompleted": "Vous y étiez presque! Vous avez manqué le bonus de %{potentialBonusPoints} %{customPoints} de %{activitytCompletedPercentage}%.",
            "titleCompleted": "Félicitations! Vous avez gagné",
            "titleCompletedBold": "le bonus de %{potentialBonusPoints} %{customPoints}!",
            "subtitle": "En savoir plus sur le bonus de %{customPoints}"
        },
        "modal": {
            "title": "Bonus de %{customPoints}",
            "desc1": "Nous savons que personne n'est parfait et ne peut atteindre tous ses objectifs.",
            "desc2": "C'est pourquoi nous accordons des  %{customPoints} bonus lorsque votre progression globale est de 85% ou plus.",
            "desc3": "Tous les bonus de %{customPoints} sont accordés une fois que l'objectif est terminé. Si tous vos suivis ont été effectués à partir d'une application ou d'un appareil connecté, le bonus est doublé!",
            "desc4": "Vous ne recevrez pas le bonus de %{customPoints} pour les objectifs que vous quittez prématurément."
        },
        "msg": {
            "title": "Cet objectif est terminé",
            "subtitle": "Objectif terminé le %{goalEndedDate}"
        },
        "msgEnded": {
            "title": "Le temps est écoulé! Votre objectif est terminé",
            "subtitle": "Vous avez %{daysNum} %{daysOrDay} pour suivre votre activité."
        }
    },
    "finish": "Terminer",
    "personalGoal": {
        "all_goals": {
            "selected": "Tous les %{maxGoals} objectifs ont été fixés!",
            "description": "Ces objectifs vous conviennent-ils? Vous pouvez remplacer n'importe quel objectif si vous changez d'avis. Ne vous inquiétez pas, vous pourrez annuler votre objectif ultérieurement.",
            "set": "Tous les objectifs ont été fixés!",
            "action": "Vous voilà prêt à commencer!",
            "error": "Ne vous emballez pas trop! Nous vous recommandons de vous concentrer sur un maximum de 3 objectifs structurés à la fois pour augmenter vos chances de réussite.",
            "errorHeading": "Établissement d'objectifs"
        },
        "set_more": "Vous pouvez fixer %{maxGoals} objectifs actifs supplémentaires",
        "select_goal": {
            "heading": "Fixer un objectif recommandé ou créer le vôtre"
        },
        "set_more_1": "Vous pouvez fixer 1 objectif actif supplémentaire"
    },
    "restartPersonalGoal": "Relancer un objectif avec de nouvelles cibles",
    "delete_challenge_confirmation": "Voulez-vous vraiment supprimer ce défi?",
    "personal_goal_unit": "objectif",
    "personal_goal_units": "objectifs",
    "day_summary": {
        "steps_taken": "Pas effectués",
        "calories_in": "Calories consommées",
        "calories_out": "Calories dépensées",
        "avg_daily": "moy. quotidienne",
        "most_earned_daily": "max. gagné en un jour"
    },
    "invitedBy": "Invité par %{person}",
    "resetPasswordMissingField": "Saisissez une adresse de courriel",
    "resetPasswordInvalidValue": "Saisissez une adresse de courriel valide",
    "resetPasswordNotFound": "Impossible de trouver votre adresse de courriel",
    "resetPasswordNotCompleted": "Impossible de traiter votre demande",
    "resetGoalInstructions": {
        "start": "Effectuez %{quantity} %{units} de %{activity}",
        "additional": ", %{quantity} %{units} de %{activity}",
        "end": "%{frequency} et gagnez %{points} %{customPoints} %{frequency}"
    },
    "goalSet": {
        "one": "Un objectif fixé. Afficher",
        "two": "Deux objectifs fixés. Afficher",
        "three": "Trois objectifs fixés. Afficher",
        "none": "Aucun objectif fixé. Fixer des objectifs"
    },
    "searchCommunitiesEmpty": "Aucune communauté n'a été trouvée",
    "searchCommunitiesPlaceholder": "Rechercher des communautés",
    "updating": "Mise à jour…",
    "pts_tracked": "A suivi %{activityName} - %{num} %{customPoints}",
    "improving_wellbeing_score": "Continuez sur cette voie, vous êtes bien parti pour améliorer votre score santé.",
    "progressHistory": "Historique de progression",
    "privateCommunity": "Il s'agit d'une communauté privée",
    "do_combo_of_activities": "Effectuez plusieurs des activités suivantes.",
    "noActivitiesTracked": "Aucune activité ajoutée",
    "trackingWithFollowingApps": "Suivi avec les applications\/appareils suivants",
    "recommendedApps": "Applications\/appareils recommandés pour ce %{challengeType}",
    "collapseWord": "Réduire",
    "started": "Date de début",
    "ends": "Se termine",
    "do_activities": "Fréquence",
    "rewards_placeholder": "Exemples de récompenses de la boutique, paramètre fictif. Les utilisateurs verront divers produits qu'ils pourront acheter et leur coût dans %{rewardName}.",
    "personalGoals": {
        "top": {
            "label": "Meilleures"
        },
        "allGoals": "Tous les objectifs",
        "seeMoreCard": {
            "heading": "Vous ne trouvez pas ce que vous recherchez?",
            "description": "Jetez un coup d'œil à l'ensemble des objectifs qui vous sont recommandés",
            "button": "Découvrir les objectifs"
        }
    },
    "rewardsNotAvailable": "Les récompenses ne sont pas disponibles à l'heure actuelle dans cette version bêta. Dès qu'elles seront disponibles, vous pourrez consulter le catalogue et les échanger contre des points.",
    "editProfileProvideRestingHeartRate": "Veuillez indiquer une valeur de fréquence cardiaque au repos d'au moins 40",
    "liveBetterHealthInfo": "Nous menons de nombreux programmes conçus pour répondre à divers besoins en matière de santé. Si vous répondez à la question suivante, nous communiquerons avec vous si nous trouvons des programmes ou des services de santé auxquels vous pouvez participer et qui vous seront bénéfiques. Veuillez noter que nous n'utilisons pas ces renseignements pour évaluer l'adéquation de votre police. Si vous souhaitez savoir la portée de votre police ou avez des questions concernant cette dernière, vous pouvez appeler notre assistance clientèle au 132 331.",
    "deleteGoalToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Vous avez supprimé l'objectif"
        }
    },
    "deleteChallengeToast": {
        "success": {
            "title": "%{title_name}",
            "message": "Vous avez supprimé le défi"
        }
    },
    "invitations": "Invitations",
    "learnMorePeriods": "En savoir plus sur les périodes",
    "tracked_by_app_name": "Suivi par %{app_name}",
    "device_required": {
        "text": "L'objectif %{challengeType} nécessite une application ou un appareil",
        "button": "Connecter une application ou un appareil"
    },
    "editingCommunityToast": {
        "success": {
            "title": "Modifier la communauté",
            "message": "La communauté a été modifiée"
        }
    },
    "competition": "Compétition",
    "close": "Fermer",
    "only_automatic_activities_with_device": "Les activités liées à cet %{goal_or_competition} sont automatiquement enregistrées par vos applications\/appareils connectés.",
    "only_automatic_activity_with_device": "L'activité liées à cet %{goal_or_competition} sont automatiquement enregistrées par vos applications\/appareils connectés.",
    "deletingCommunityToast": {
        "success": {
            "title": "%{name}",
            "message": "Communauté supprimée"
        }
    },
    "teamSizeMessage": "Votre équipe a besoin d'au moins %{min} personnes pour gagner des %{customPoints} pour le défi.",
    "captain": "Capitaine",
    "inviteOthersToTeam": "Inviter à rejoindre mon équipe",
    "loadingMetrics": "Connexion aux sources pour mettre à jour votre journée…",
    "aboutTeamSize": {
        "title": "Taille de l'équipe",
        "text": "%{min} à %{max}"
    },
    "pointsOverview": "Vue d'ensemble des %{customPoints}",
    "deepLinks": {
        "requestCouldNotBeCompleted": "Impossible de traiter votre demande",
        "error": "Erreur"
    },
    "required_lc": "obligatoire",
    "personal": "Données personnelles",
    "biometrics": "Données biométriques",
    "makeSelection": "Sélectionner",
    "ask_question_success_msg": "Merci d'avoir envoyé votre question. Nous y répondrons aussitôt que possible.",
    "report_issue_success_msg": "Merci d'avoir envoyé votre problème technique. Nous le corrigerons aussitôt que possible.",
    "ask_question_success_title": "Question envoyée",
    "report_issue_success_title": "Problème technique envoyé",
    "ask_question_failure_msg": "Zut… une erreur s'est produite lors de l'envoi de votre question. Veuillez réessayer. ",
    "report_issue_failure_msg": "Zut… une erreur s'est produite lors du signalement de votre problème. Veuillez réessayer. ",
    "notTrackedActivities": "Vous n'avez ajouté aucune activité pour cette période",
    "learn": "Apprendre",
    "Balance": "Solde",
    "details": "Détails",
    "Reward": "Récompense",
    "levelsReset": "Niveaux réinitialisés dans %{remainingDays} jours",
    "redeem": "Échanger",
    "redeemAt": "Échanger contre %{points}",
    "needPointsToRedeem": "Vous avez besoin de %{points} supplémentaires pour %{rewardName}.",
    "learnEarnMore": "Découvrir comment en obtenir plus",
    "currency": "SproutBucks",
    "joiningTeamChallengeToast": {
        "success": {
            "title": "Rejoindre l'équipe",
            "message": "Vous avez bien rejoint l'équipe!"
        },
        "danger": {
            "message": "Une erreur s'est produite et nous n'avons pas pu trouver l'équipe. Celle-ci n'existe peut-être plus."
        }
    },
    "NoMatchingDeepLinkToast": {
        "danger": {
            "title": "Action non disponible",
            "message": "Impossible de traiter votre demande."
        }
    },
    "transactionLog": "Transactions",
    "orderHistory": "Commandes",
    "pointsAvailableToEarn": "%{points} à gagner",
    "missedYTD": "%{missed} manqué(s) depuis le début de l'année",
    "rewardsDetails": "Récompenses",
    "successfullyRedeemedItem": "Votre commande est confirmée",
    "orderNumber": "Numéro de commande",
    "amountSpent": "Montant dépensé",
    "status": "Statut",
    "dateRedeemed": "Date de l'échange",
    "additionalInformation": "Renseignements supplémentaires",
    "shipToAddress": "Expédier à cette adresse",
    "pointMissedYearToDate": "%{rewardCurrencyName} manqué(s) cette année",
    "pointMissedYearToDateDescription": "Lorsque vous n'atteignez pas un niveau avant la fin de la période, la récompense %{rewardCurrencyName} associée que vous auriez pu gagner est considérée comme manquée.",
    "NoLibraryContentToast": {
        "info": {
            "title": "Article introuvable",
            "message": "Impossible de trouver l'article. Celui-ci a peut-être été supprimé ou n'est plus disponible."
        }
    },
    "CommunityNotFoundToast": {
        "danger": {
            "title": "Communauté introuvable",
            "message": "Impossible de trouver la communauté. Celle-ci a peut-être été supprimée ou n'est plus disponible."
        }
    },
    "shippingAddress": "Adresse de livraison \/ de facturation",
    "enterShippingAddress": "Saisissez votre adresse de livraison \/ de facturation",
    "streetLine": "Nom de rue %{num}",
    "stateProvince": "Territoire\/Province",
    "postcodePostalcodeZip": "Code postal",
    "phoneNumber": "Numéro de téléphone",
    "order": "Commande",
    "redemptionConfirmation": "Confirmation de l'échange",
    "edit": "Modifier",
    "processing": "Traitement",
    "checkIsYouFirst": "Nous devons d'abord confirmer qu'il s'agit bien de vous",
    "discardSomeGoals": "Vous avez fixé plusieurs objectifs. Ces objectifs seront abandonnés si vous continuez.",
    "settingGoalsToast": {
        "success": {
            "message": "Vos nouveaux objectifs ont été fixés!"
        }
    },
    "one_team": "1 équipe",
    "noAchievementsToEarnMessage": "On dirait qu'il n'y a plus de médailles pour gagner %{rewardCurrencyName} au cours de cette période.",
    "shopRewards": "Acheter des récompenses",
    "validateShippingAddressToast": {
        "danger": {
            "title": "Adresse de livraison \/ de facturation",
            "message": "Remplissez tous les champs avant de continuer."
        }
    },
    "viewDetails": "Afficher les détails",
    "potential": "Points potentiels",
    "missed": "Manqué(s)",
    "rewardsStoreNotAvailable": "Vous n’avez pas encore accès à la boutique de récompenses.",
    "havent_tracked_in_a_while_date": "Aucune activité ajoutée pour le %{currentDate}",
    "challengeNotFoundToast": {
        "danger": {
            "title": "Défi introuvable",
            "message": "Nous n’avons pas pu trouver le défi. Celui-ci a peut-être été supprimé ou n'est plus disponible."
        }
    },
    "shareYourDaySubtitleActivity": "Ajoutez une image ou du texte à propos de cette activité!",
    "goal_ended": "Objectif terminé",
    "challenge_ended": "Défi terminé",
    "day_remaining_to_track": "Il vous reste un jour pour ajouter les activités manquantes",
    "challengeGoalCardSubtitleEndDate": "%{challengeOrGoal} terminé le %{endDate}",
    "goalEndedModal": {
        "title": "Ajouter les activités oubliées",
        "message": "Vous disposez d’un délai de trois jours à partir de la date de fin d’un objectif personnel ou d’un défi pour ajouter les activités que vous auriez oubliées. Passé ce délai, vous ne pouvez plus ajouter d’activité supplémentaire liée à l’objectif ou au défi."
    },
    "summary": "Résumé",
    "placedRank": "Vous êtes %{rank} sur %{total}",
    "rank": {
        "first": "1ᵉʳ",
        "second": "2ᵉ",
        "third": "3ᵉ",
        "n": "%{rank}ᵉ"
    },
    "event_name": "Nom de l’événement",
    "this_is": "Il s'agit d'un",
    "location_info": "Lieu et renseignements",
    "what_event": "Sujet de cet événement",
    "event_is": "Cet événement est",
    "start_on": "Date de début :",
    "end_on": "Date de fin :",
    "location": "Lieu",
    "chooseLeaderboard": "Choisir un classement",
    "filterOneOfFollowing": "Filtrer à partir de l’un des éléments suivants",
    "showChallengeInstead": "Afficher un défi à la place",
    "showActivityInstead": "Afficher une activité à la place",
    "showAll": "Tout afficher",
    "activitiesShowSame": "Activités : %{activityName}",
    "challengeShowSame": "Défi : %{challengeName}",
    "chooseTimePeriod": "Choisir une durée",
    "youCanFilterOneAtTime": "Vous ne pouvez filtrer qu’un élément à la fois",
    "saveHealthTopicsToast": {
        "success": {
            "message": "Sujets de santé enregistrés",
            "title": "Opération réussie."
        },
        "info": {
            "message": "Enregistrement impossible"
        },
        "danger": {
            "title": "Erreur!"
        }
    },
    "saveHealthObjectivesToast": {
        "success": {
            "message": "Objectifs de santé enregistrés",
            "title": "Opération réussie."
        },
        "info": {
            "message": "Enregistrement impossible"
        },
        "danger": {
            "title": "Erreur!"
        }
    },
    "saveInterestGroupsToast": {
        "success": {
            "message": "Centres d’intérêt enregistrés",
            "title": "Opération réussie."
        },
        "info": {
            "message": "Enregistrement impossible"
        },
        "danger": {
            "title": "Erreur!"
        }
    },
    "edit_event": "Modifier un événement",
    "leave": "Quitter",
    "delete_event": "Supprimer un événement",
    "no_events": "Aucun événement",
    "no_events_placeholder": "Vous ne prévoyez pas actuellement assister à d'autres événements. Pourquoi ne pas en rejoindre un?",
    "event": "événement",
    "challenge": "Défi",
    "invited_you": "Vous a invité",
    "public": "Public",
    "private": "Privé",
    "deleteEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Événement supprimé."
        }
    },
    "leaveEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Vous avez quitté l’événement"
        }
    },
    "editEventToast": {
        "success": {
            "title": "%{eventName}",
            "message": "Événement mis à jour."
        }
    },
    "createEventToast": {
        "success": {
            "message": "Événement créé.",
            "title": "%{eventName}"
        }
    },
    "contentIsDeletedOrInappropriate": "Le contenu que vous essayez d’afficher n’est pas disponible à l’heure actuelle. Il a peut-être été supprimé par l’auteur ou marqué comme inapproprié.",
    "start_time": "Heure de début",
    "end_time": "Heure de fin",
    "event_type": "Événement %{eventType}",
    "leave_event_modal": {
        "title": "Si vous quittez cet événement",
        "message": "Il sera supprimé"
    },
    "leave_event ": "Voulez-vous vraiment quitter cet événement?",
    "create_event": "Créer un événement",
    "created_by": "Créé par",
    "eventActionToast": {
        "danger": {
            "title": "Erreur",
            "message": "Une erreur s’est produite."
        }
    },
    "continue": "Continuer",
    "wantExitTour": "Voulez-vous vraiment quitter la visite?",
    "exitTour": "Quitter la visite",
    "deleveEventPopup": "Voulez-vous vraiment quitter cet événement?",
    "attendeesTitle": "Participants",
    "userEvents": "Événements de %{name}",
    "createEventIndicator": "Création de l’événement",
    "inviteToEvent": "Inviter à participer à l’événement",
    "noDescription": "Il n’y a pas de description.",
    "leaderboardIsEmpty": "Ce classement est vide ou il faut peut-être faire ajouter une activité pendant la période sélectionnée pour le voir",
    "notParticipantingInAnyChallenges": "Vous ne participez à aucun défi",
    "buttonLeaveEvent": "Quitter l’événement",
    "leaveEvent ": "Quitter %{name}?",
    "canceledCreatingChallenge": "Création d'un %{challengeType} annulée",
    "swipeReadNotification": "Lire",
    "productTour": {
        "initialScreen": {
            "title": "Bienvenue sur %{programName}!",
            "body": "Et si nous faisions une petite visite afin de vous expliquer les principes de base en quelques minutes?"
        },
        "dashboard": {
            "title": "Tableau de bord",
            "body": "Consultez votre nombre de %{pointsName} ainsi que votre progression. Jetez ensuite un œil au classement pour évaluer votre performance."
        },
        "rewards": {
            "title": "Récompenses",
            "body": "Consultez votre nombre de %{rewardPointName} et échangez-les dans la boutique."
        },
        "goals": {
            "title": "Objectifs et défis",
            "body": "Vos objectifs personnels actifs, vos défis avec les autres utilisateurs ainsi que vos tâches spéciales s’affichent ici."
        },
        "explore": {
            "title": "Découvrir",
            "body": "Participez à des défis entre collègues, rejoignez des communautés pour parler de vos intérêts et découvrez de nouveaux articles dans la bibliothèque de bien-être."
        },
        "me": {
            "title": "Moi",
            "body": "Consultez votre score santé et vos statistiques et modifiez votre profil et vos paramètres sur cette page."
        },
        "finishScreen": {
            "title": "C'est fait!",
            "body": "Merci d’avoir suivi notre visite.",
            "button": "À vous de jouer"
        },
        "skip": {
            "title": "Voulez-vous vraiment ignorer la visite?",
            "body": "La visite prendra fin et vous pourrez commencer tout de suite."
        }
    },
    "getTemporaryRewardRedemptionTokenToast": {
        "danger": {
            "title": "Échec de l’authentification",
            "message": "Impossible de continuer l’échange de récompense. Une erreur s’est produite lors de l’authentification du fournisseur de récompenses."
        }
    },
    "rewardRedemptionFailureToast": {
        "danger": {
            "title": "Échec de l’échange",
            "message": "%{displayMessage}"
        }
    },
    "disclamerSectionTitle": "Avant de commencer",
    "disclamerSectionMessage": "Consultez votre médecin avant de commencer un nouveau programme sportif ou de changer votre mode de vie afin de vous assurer que ces changements sont adaptés.",
    "noEarchedAchievements": "Vous n’avez pas encore obtenu de médaille. Ajoutez une activité pour commencer.",
    "noInProgressAchievements": "Vous n’avez aucune médaille en cours.",
    "discardCreatingEventMessage": "Assurez-vous que tous les champs requis ont été remplis",
    "discardCreatingEventTitle": "Impossible de créer l’événement",
    "discardEditedEventTitle": "Impossible de modifier l’événement",
    "errorEventNameMessage": "Nom requis",
    "errorEventStartDateMessage": "Date de début requise",
    "errorEventEndDateMessage": "Date de fin requise",
    "errorEventDateMessage": "La date de fin ne peut pas être antérieure à la date de début",
    "noAccountsToLink": "Aucun compte n'est disponible pour être associé à %{program_name}.",
    "accountLinkEmailChanged": "Votre adresse de courriel a été mise à jour. À partir de maintenant, connectez-vous avec votre compte associé.",
    "accountLinkSuccessful": "Votre compte a été associé.",
    "edit_profile_nan_value": "La valeur doit correspondre à un nombre",
    "advancedLogIn": "Connexion avancée",
    "redemptionSessionExpiredToast": {
        "danger": {
            "title": "Échec de l’échange",
            "message": "La session de commande a expiré. Réessayez de passer votre commande."
        }
    },
    "left": "restant(s)",
    "eventsCarousel": {
        "emptyEvent": {
            "prompt": "On dirait qu'il n’y a aucun événement disponible à l’heure actuelle. Pourquoi ne pas en créer un?"
        }
    },
    "reachedHighestLevel": "Vous avez atteint le plus haut niveau!",
    "error": "Erreur",
    "redeemRewardSuccessfulToast": {
        "success": {
            "title": "Commande passée",
            "message": "Votre commande a été passée"
        }
    },
    "redeemRewardComplete": "Échange terminé",
    "trackActivityTitle": {
        "oneUnit": "Suivre : 1 %{unit} de %{activity} le %{date}",
        "nUnit": "Suivre : %{activity} pour le %{date}"
    },
    "ssoAuthenticationFailure": "Échec de l’authentification",
    "earnEvery": "Gagner tous les %{frequency}",
    "earnOnce": "Gagner une seule fois",
    "goalSettings": {
        "maximumSet": "Vous avez actuellement fixé le maximum de 3 objectifs.",
        "learnMore": "En savoir plus sur l’établissement d'objectifs"
    },
    "allowMarketingComms": "M’envoyer des communications promotionnelles",
    "allowPartnerMarketingComms": "M’envoyer des communications promotionnelles de partenaires",
    "noUpcomingAchievements": "Vous n’avez aucune médaille à venir.",
    "settingGoalToast": {
        "success": {
            "message": "Vos nouveaux objectifs ont été fixés!"
        }
    },
    "authentication": {
        "saml": {
            "error": "Service actuellement indisponible",
            "signin": "Connexion intégrée",
            "signup": "Inscription intégrée"
        }
    },
    "monthName": {
        "january": "Janvier",
        "february": "Février",
        "march": "Mars",
        "april": "Avril",
        "may": "Mai",
        "june": "Juin",
        "july": "Juillet",
        "august": "Août",
        "september": "Septembre",
        "october": "Octobre",
        "november": "Novembre",
        "december": "Décembre"
    },
    "promotedForMe": "En vedette",
    "appRating": {
        "enjoying": "Vous appréciez notre application?",
        "feedback": "Souhaitez-vous nous faire part de vos commentaires?",
        "appStore": "Évaluez-nous dans l'App Store?",
        "googlePlay": "Donnez-nous votre avis sur Google Play?",
        "notReally": "Pas vraiment",
        "yes": "Oui!",
        "sure": "D'accord ",
        "noThanks": "Non merci",
        "notNow": "Pas maintenant"
    },
    "getMobileApp": "Pour utiliser %{programName} sur votre smartphone, téléchargez %{appStoreName} sur l'App Store ou sur Google Play.",
    "newAppsDevicesDesign": {
        "getMobileApp": "Téléchargez l'application %{programName}",
        "searchInAppStore": "Recherchez %{programName} dans la boutique d'applications de votre appareil",
        "getMobileAppNoName": "Obtenir l'application mobile"
    },
    "editorAlert": {
        "discardChanges": "Annuler les modifications",
        "saveAndContinue": "Sauvegarder et continuer",
        "title": "Modifications non enregistrées",
        "text": "Vous avez apporté des modifications qui n'ont pas été enregistrées. Que voulez-vous faire?"
    },
    "resources": "Ressources",
    "noResources": "Aucune ressource disponible",
    "viewAllResources": "Voir toutes les ressources",
    "language": "Langue",
    "eventStarted": "L'événement a commencé. L'inscription est fermée.",
    "Gender": "Sexe",
    "show": "Afficher",
    "hide": "Masquer",
    "timeoutError": "Oups! Quelque chose prend trop de temps. Veuillez réessayer plus tard.",
    "SOT": {
        "sample_task": "Exemple de tâche"
    },
    "cache": {
        "new_version": "Une nouvelle version est disponible!",
        "refresh_browser": "Cliquez ici pour rafraîchir votre navigateur."
    },
    "welcomeUser": "Bienvenue, %{userFirstName}!",
    "quarter": "trimestre",
    "completionReward": "Récompense",
    "bronzeLevel": "Niveau de bronze",
    "deviceAppSyncingOk": "Synchronisation réussie",
    "deviceAppSyncingIssue": "Problème de synchronisation",
    "deviceAppSyncingError": "Erreur de synchronisation",
    "lastSync": "Dernière synchronisation",
    "period": "période",
    "yourDaySummary": "Votre journée jusqu’à présent",
    "steps": "Pas",
    "gender_non_binary": "Non binaire ou non conforme",
    "take_survey": "Compléter le questionnaire",
    "social": "Social",
    "finalDay": "Dernier jour",
    "leaderboard_position": "Position au classement",
    "signUp": {
        "apple": {
            "disconnectSettings": "Déconnectez %{appName} de \"Mot de passe associé à l'identifiant Apple et sécurité\" dans les paramètres du téléphone pour poursuivre l'inscription"
        }
    },
    "earnPoints": "Accumuler des %{customPoints}. Montez de niveau.",
    "getReward": "Accumulez des %{rewardName}.",
    "buildHealthyHabits": "Développez des habitudes saines.",
    "highestLevelIndicator": "Vous avez atteint le plus haut niveau!",
    "highestLevelIndicatorNew": "Vous avez terminé tous les niveaux!",
    "trackYourActivity": "Pour accumuler des %{customPoints}, consignez votre activité physique.",
    "levelUpToGetRewarded": "Lorsque vous augmentez de niveau, vous accumulez des %{rewardName}.",
    "levelUpAndEarn": "Votre progrès est remis à zéro à chaque %{period}, alors vous pouvez continuer à augmenter de niveau et à accumuler sans arrêt.",
    "levelUp": "Votre progrès est remis à zéro à chaque %{period}, alors vous pouvez continuer à monter de niveau sans arrêt.",
    "goToLibrary": "Accéder à la bibliothèque",
    "updateEventIndicator": "Édition de l'événement",
    "meTour": {
        "healthSurveyDisabled": "Consultez vos statistiques et modifiez votre profil et vos paramètres sur cette page."
    },
    "createNewGoal": "Créer un nouvel objectif",
    "later": "Plus tard",
    "bonusChallenge": "Défi bonus",
    "bonusChallengeInfo": {
        "withReward": "Vous obtiendrez %{amount} %{points} bonus si vous complétez au moins 85% de ce %{challengeType}.",
        "noReward": "Vous obtiendrez un bonus si vous complétez au moins 85% de ce défi.",
        "boldText": "%{amount} %{points} bonus",
        "noRewardChallengeType": "Vous gagnerez un bonus pour avoir complété au moins 85% de ce %{challengeType}"
    },
    "defaultApp": "Votre application de santé par défaut",
    "bonusGoal": {
        "additionalInfo": "Si toutes vos activités ont été enregistrées à l’aide d’une appli ou d’un appareil connecté, vous recevrez le double des %{points} bonus!",
        "additionalInfoNew": {
            "paragraph2": "Les %{points} bonus sont attribués une fois l’objectif terminé. Vous ne recevrez pas de %{points} bonus pour les objectifs que vous quittez avant la fin."
        },
        "boldText": "le double des %{points} bonus!",
        "markTitle": "Objectif de bonus"
    },
    "notify_me": "Recevoir des notifications",
    "bonusChallengeReward": "Récompense boni de défi",
    "forCompletingChallenge": "Pour avoir complété le défi %{challengeName}",
    "notifications_text": "Les notifications vous aident à respecter vos objectifs et à rester à l’affût des nouvelles.",
    "type_here": "Entrez votre texte ici",
    "bonusEarned": "Bonus gagné",
    "youEarnedBonus": "Vous avez mérité ce boni!",
    "inviteOthersToChallenge": "Inviter des gens à relever le défi",
    "inviteOthersToYourTeam": "Recruter des coéquipiers",
    "manageTeam": "Gérer l’équipe",
    "ft": "pi",
    "lbs": "lb",
    "cm": "cm",
    "kg": "kg",
    "community": "communauté",
    "chooseActivity": "Choisir l’activité",
    "Recent": "Récente",
    "noActivities": "Aucune des activités ne lui ressemble",
    "photoChooseText": "Choisir",
    "photoCancelText": "Annuler",
    "signIn": {
        "missingEmail": "Courriel manquant",
        "missingPassword": "Veuillez vous assurer que le mot de passe est fourni",
        "invalidLogin": "Connexion non valide",
        "accountLocked": "Votre compte est verrouillé. Veuillez contacter votre administrateur",
        "accountMayNotExist": "Nous n'avons pas de compte pour cette adresse électronique. Inscrivez-vous pour créer un compte.",
        "wrongPassword": "Mauvais mot de passe. Réessayez ou cliquez sur Mot de passe oublié pour le réinitialiser."
    },
    "deleteGoalBonusPoints": "Vous ne pourrez plus le faire si vous n’avez pas encore gagné le bonus associé.",
    "havent_tracked_goal": "Vous n'avez suivi aucune activité dans ce but",
    "trackActivity": {
        "search": "Recherche d’activités...",
        "text": "Suivre l’activité",
        "done": "Fait",
        "discardChanges": "Jeter les modifications?",
        "discardMessage": "Êtes-vous sûr de vouloir quitter et de jeter votre progrès?",
        "discard": "Jeter",
        "limitMessage": "Vous ne pouvez suivre jusqu’à sept jours à la fois.",
        "inputDescription": "Quantité de %{activity} pour %{date}",
        "gracePeriod": "Il vous reste %{n} %{text} pour suivre toute activité manquée"
    },
    "dates": "Dates",
    "pickDates": "Choisir d'autres dates",
    "selectDates": "Sélectionner des dates",
    "limitReached": "Vous avez atteint la limite",
    "activity": "Activité",
    "keepUpTheGoodWork": "Continuez le bon travail !",
    "activityTracked": "Activité suivie",
    "new": "Nouveau",
    "newFeatureTitle": "Un suivi des activités plus facile et plus rapide",
    "newFeatureText": "Que vous suiviez l'activité d'aujourd'hui, du passé ou de plusieurs jours, nous pensons que vous adorerez cette nouvelle expérience.",
    "gotIt": "J'ai compris !",
    "frequencyViewHistory": "Voir la répartition %{frequency}",
    "challengeDetails": {
        "trackTheseActivities": "Suivez toutes ces activités pour progresser vers ce %{challengeType}."
    },
    "member": "membre",
    "weeklyBreakdown": "Répartition hebdomadaire",
    "setGoals": {
        "earnPointsText": {
            "start": "Gagnez",
            "end": "pour avoir fixé votre premier objectif!"
        }
    },
    "weeklyGoalEnded": "La semaine s'est achevée le",
    "weekFinished": "Vous avez terminé une semaine de",
    "restartGoal": {
        "daysLeftToTrack": "Il vous reste %{quantity} %{days} pour suivre tout progrès oublié de la semaine dernière.",
        "weekEnded": "Cette semaine s'est achevée.",
        "timesUp": "Le temps est écoulé!",
        "period": {
            "title": "Période de l’objectif",
            "text": "Du lundi au dimanche, toutes les semaines"
        }
    },
    "membersPlural": "Membres",
    "startedADayAgo": "Commencé il y a 1 jour",
    "goalRestarted": "Vous avez recommencé cet objectif",
    "weeklyGoals": "Objectifs hebdomadaires",
    "weeklyGoalsDescription": "Les objectifs hebdomadaires se renouvellent chaque lundi afin que vous puissiez garder une habitude saine sur une longue période de temps.",
    "challengeEnded": "Cet %{challengeType} est terminé",
    "goalEndedModalTitle": "Ajouter les activités oubliées",
    "yourProgress": "Votre progrès",
    "earn_withRewards": "Suivez votre activité saine pour gagner (%{pts}) et réussir les niveaux. Lorsque vous passerez au niveau supérieur, vous obtiendrez %{currency}.",
    "earn_noRewards": "Suivez votre exercice et votre activité de bien-être pour gagner (%{pts}) et passer au niveau supérieur.",
    "currentPeriod": "Période en cours",
    "currentScore": "Score actuel",
    "viewActivityLog": "Afficher le journal des activités",
    "balanceHistory": "Mon historique des soldes",
    "mymedibank": {
        "underAge": {
            "error": "L'application Live Better n'est disponible que pour les utilisateurs âgés de 18 ans et plus. Pour plus d'informations, reportez-vous aux Conditions générales de Live Better."
        }
    },
    "enhancedHomePageInfo": "Nous avons nettoyé la page d'accueil! Il est maintenant plus facile de voir vos défis et vos objectifs. Il est temps de suivre!",
    "levelUpTitle": "Gagnez des niveaux",
    "levelUpDescription": "Gagnez des niveaux en suivant les activités et en réalisant les objectifs et les défis. À mesure que vous gagnez des niveaux, vous serez récompensé avec %{currency}!",
    "achievementsDescription": "Débloquez ces récompenses spéciales pour gagner %{currency}. Cliquez sur un badge pour savoir ce que vous devez faire.",
    "bonusChallengesDescription": "Rejoignez et complétez les défis qui ont un bonus de %{currency}.",
    "earnWithPartners": {
        "title": "Gagnez des points avec des partenaires",
        "description": "Les membres Medibank avec une couverture hospitalière ou extras peuvent gagner des points sur les achats\/activités éligibles avec des partenaires."
    },
    "browseAllPartners": "Parcourir tous les partenaires",
    "resetsIn": "Se réinitialise dans %{daysNumber} jours",
    "thisIsALot": "C'est beaucoup!",
    "areYouSure": "Vous êtes sûr?",
    "trackingALotMessage": {
        "days": "Vous suivez plus de 2 000 %{customPoints} sur %{daysNum} jours. C'est beaucoup!",
        "day": "Vous suivez plus de 2 000 %{customPoints} en 1 jour. C'est beaucoup!"
    },
    "amSure": "J'en suis sûr",
    "activeMinutesAndSleep": {
        "title": "Les minutes actives et le sommeil sont mesurés par l'appareil",
        "description": "Votre appareil enregistre les minutes actives lors d'une activité physique d'intensité modérée ou élevée - c'est un bon exercice! Vous utilisez un appareil pour surveiller votre sommeil? Vous gagnerez %{points} pour cela également!"
    },
    "hourShort": "h",
    "hoursShort": "h",
    "secondsShort": "sec",
    "watchToEarn": "Regardez pour gagner",
    "oneParticipant": "1 participant",
    "oneTeam": "1 Équipes",
    "numberOfTeams": "%{num} teams",
    "inviteToYourTeam": "Invitez à rejoindre votre équipe",
    "inviteToThisChallenge": "Inviter à participer à ce défi",
    "challengeInstructionText": "Suivez cette activité pour progresser vers votre %{challengeType}.",
    "showLess": "Moins",
    "startsTomorrow": "Commence demain",
    "deadlineDayLeft": "jour restant",
    "deadlineDaysLeft": "jours restants",
    "deviceBonus": "bonus de l'appareil associé",
    "appsAndDevices": {
        "header": "Applications et appareils",
        "linked": "Ces applications et appareils associés permettent d'atteindre ce %{challengeType}:",
        "noLinked": "Aucune application ou appareil application adéquat lié",
        "link": "Associez votre téléphone, votre montre ou votre application pour effectuer un suivi automatique."
    },
    "yourGoals": "Vos objectifs",
    "yourChallenges": "Vos défis",
    "position": "Classmt",
    "team_success": "Succès de l'équipe",
    "starts_in": "Commence dans",
    "team_challenge": "Défi d'équipe",
    "your_progress_today": "Votre progrès aujourd'hui",
    "your_daily_avarage": "Votre moyenne quotidienne est de",
    "this_week_progress": "Progrès de cette semaine",
    "this_month_progress": "Progrès de ce mois",
    "overall_progress": "Progrès global",
    "complete": "terminé",
    "overallSuccess": "Succès global",
    "teamSuccessAverage": "Moyenne du succès de l'équipe",
    "progressDetails": "Détails du progrès réalisé",
    "dayStreak": "Série de %{n} jours!",
    "weekStreak": "Série de %{n} semaines!",
    "dailyProgress": "Progrès quotidiens",
    "participantsSuccessCount": {
        "overall": "%{amount} des %{total} participants ont atteint l'objectif",
        "day": "%{amount} des %{total} participants ont atteint l'objectif aujourd'hui",
        "week": "%{amount} des %{total} participants ont atteint l'objectif cette semaine",
        "month": "%{amount} des %{total} participants ont atteint l'objectif ce mois"
    },
    "doubleBonusShort": "Double bonus!",
    "doubleBonusLong": "Vous avez gagné un double bonus!",
    "recommendedGoalDescription": "Les objectifs vous aident à suivre vos progrès et à rester motivé!",
    "noParticipation": "Aucune participation",
    "nothingToShow": "Il semblerait qu'il n'y ait rien à montrer en ce moment",
    "yourTeam": "Votre équipe",
    "no_activity_title": "Aucune activité",
    "brandSupport": {
        "description": "Nous avons ajouté la fonctions support pour la synchronisation des activités avec les montres intelligentes Polar et Withings. Il est temps de bouger!"
    },
    "no_tracked_activities": "Vous n'avez encore suivi aucune activité",
    "button_leave_community": "Quitter la communauté",
    "button_delete_challenge": "Supprimer %{challengeType}",
    "button_delete_community": "Supprimer la communauté",
    "button_delete_activity": "Supprimer l'activité",
    "library_header_description": "Contenu original pour vous éduquer, susciter votre intérêt et vous inspirer dans votre quête de bien-être.",
    "library_searchbar": "Rechercher dans la bibliothèque…",
    "library_page_header": "Contenu original pour vous éduquer, susciter votre intérêt et vous inspirer dans votre quête de bien-être",
    "onboarding_button_title": "J'ai terminé",
    "refresh_bar": "Cliquez ici pour mettre à jour",
    "content": {
        "min_read": "%{readingTime} minutes de lecture"
    },
    "noMembers": "Aucun membres",
    "saved": "Enregistré",
    "forYou": "Pour vous",
    "min read (Note: min as in minutes)": "",
    "send me program related email notifications": "",
    "send me weekly email updates": "",
    "you can earn this bade once every quarter": "",
    "badgeInstruction": "%{badgeInstruction} d'ici",
    "youCanEarnThisBadge": "Vous pouvez gagner ce badge une fois par %{period}",
    "emailPreferences": "Préférences de messagerie",
    "unsubscribeText": "Désactiver toutes les mises à jour par e-mail",
    "savingText": "Économie...",
    "wrongTryLater": "Quelque chose s'est mal passé. Veuillez réessayer plus tard.",
    "preferencesSaved": "Préférences enregistrées",
    "recommendedForYou": "Recommandé pour vous",
    "formerMember": {
        "label": "Ancien membre"
    },
    "selectionsFromLibrary": "Des sélections de notre bibliothèque choisies pour vous",
    "goalsInfo": {
        "desc1": "pour vous concentrer sur l'amélioration de votre bien-être.",
        "desc2": "Vous avez le nombre maximum d'objectifs fixés."
    },
    "createMyOwn": "Créer le mien",
    "isAllSet": "est prêt!",
    "undoLabel": "Annuler",
    "terms": "Termes",
    "placeOrder": "Passer la commande",
    "item": "Article",
    "redeemFor": "Échanger contre",
    "confirmYourOrder": "Confirmer votre commande",
    "orderComplete": "Commande terminée",
    "redeemedFor": "Échangé pour",
    "orderDetails": "Détails de la commande",
    "bonusGoalReward": "Récompense d'avoir atteint l'objectif bonus",
    "orderSummary": "Récapitulatif de la commande",
    "logoutSSO": {
        "title": "Vous vous êtes déconnecté de %{programName}.",
        "description": "On se reverra bientôt!",
        "signinAgain": "Cliquez ici pour vous reconnecter"
    },
    "nothing_to_show": "Rien à afficher pour le moment",
    "no_saved_content": "Vous n'avez aucun contenu enregistré",
    "restarts_every_week": "Redémarre chaque semaine",
    "myGoals": "Mes objectifs",
    "goalGallery": "Galerie d'objectifs",
    "share_smth": "Partage quelque chose…",
    "newFeatureModal": {
        "smartGoal": {
            "title": "Notre objectif de pas est devenu plus intelligent!",
            "description": "Vos semaines sont toujours différentes - maintenant vos objectifs le sont aussi! \n Avec le Mode intelligent, votre objectif de pas s'ajustera en fonction de votre activité réelle.\n Il est défini avec votre succès et votre bien-être à l'esprit.",
            "action": "Essayez-le!"
        },
        "mePage": {
            "title": "Le nouveau moi",
            "description": "Nous avons repensé la section Moi pour faciliter la recherche des choses qui vous intéressent – ​​jetez-y un œil !",
            "letsSeeBtn": "Voyons!",
            "llaterBtn": "Peut-être plus tard"
        },
        "bellEAP": {
            "title": "Bienvenue sur votre plateforme en ligne du Programme d’aide aux employés et à la famille!",
            "description": "Découvrez les outils et les services disponibles pour vous et les membres de votre famille admissibles, afin de soutenir votre bien-être et vous aider à faire face aux défis de la vie",
            "button": "Connectez-vous maintenant ou visitez la page Liens rapides à tout moment"
        },
        "quickActivityLogView": {
            "title": " Un moyen plus rapide de voir votre activité récente",
            "description": "Vous pouvez maintenant cliquer sur la barre de progression pour voir votre journal d'activité."
        }
    },
    "goalSmartMode": {
        "title": "Mode Intelligent",
        "description": "Obtenez des objectifs hebdomadaires personnalisés en fonction de votre niveau d'activité récent.",
        "status": "Le mode intelligent est %{status} pour cet objectif.",
        "infoModal": {
            "descriptionOne": "Lorsque le mode intelligent est activé, la cible de cet objectif change d'une semaine à l'autre en fonction de votre niveau d'activité récent.",
            "descriptionTwo": "Nous vous mettrons au défi juste comme il faut pour vous préparer au succès.",
            "instructions": ""
        },
        "settings": {
            "switch": "Activer le mode intelligent pour mon objectif de pas",
            "description": "Lorsque le mode intelligent est activé, vous obtenez un nouvel objectif de pas au début de chaque semaine."
        },
        "enableSmartMode": "Activer le mode intelligent",
        "settingsModal": {
            "descriptionTurnOn": "Votre objectif cible de pas changera chaque semaine en fonction de votre niveau d'activité",
            "descriptionTurnOff": "Votre objectif cible de pas ne sera plus personnalisé chaque semaine"
        }
    },
    "On": "Allumé",
    "Off": "Éteint",
    "top_posts": "Publications les plus populaires",
    "most_recent": "Plus récent",
    "browseByTopic": "Parcourir par sujet",
    "video": "Vidéo",
    "enable": "Activer",
    "turnOff": "Éteindre",
    "new_post": "Nouveau message",
    "new_post_in": "Nouvelle publication dans",
    "dailyTarget": "Cible quotidien",
    "dailyTargetForWeek": "Cible quotidien pour la semaine",
    "showMyActivityLog": "Afficher mon journal d'activité",
    "usersReacted": {
        "oneOther": "%{userName} et 1 autre",
        "multipleOthers": "%{userName} et %{count} autres"
    },
    "reactionsModal": {
        "title": "Plus de façons de célébrer",
        "description": "Encouragez vos collègues avec de nouvelles réactions sur les réseaux sociaux !"
    },
    "account": "Compte",
    "myWellbeingProfile": "Mon profil bien-être",
    "physicalDetailsDescription": "Ces informations sont nécessaires pour calculer votre score de bien-être",
    "wellbeingInterests": "Intérêts en matière de bien-être",
    "myWellbeingInterests": "Mes intérêts bien-être",
    "preferredNameOptional": "Nom préféré (facultatif)",
    "basicPhysicalDetails": "Détails physiques de base",
    "notRegistered": {
        "infoModal": {
            "title": "Nous ne pouvons pas vous trouver",
            "notInSystem": "n'est pas dans notre système.",
            "correctEmail": "Assurez-vous d'utiliser le bon compte (généralement une adresse e-mail d'entreprise) et vérifiez les fautes de frappe.",
            "emailHelp": "Pour plus d'aide, envoyez un e-mail à notre équipe d'assistance à"
        }
    },
    "dontHaveAccount": "Vous n'avez pas de compte?",
    "wasThisHelpful": "Est-ce que cela a été utile ?",
    "healthScoreFeedbackModal": {
        "emojiSection": "Dans quelle mesure cette page et votre score de bien-être sont-ils utiles ?",
        "commentSectionText": "Comment pourraient-ils être améliorés ?",
        "commentSectionPlaceholder": "Ajouter un commentaire...",
        "thankYouModal": "Merci pour vos commentaires !"
    },
    "number_connected": "%{numDevices} connectés",
    "searchPlaceHolder": "Recherche...",
    "noTeamsFound": "Aucune équipe trouvée",
    "join_a_challenge": "Rejoignez un défi",
    "me_page_titles": {
        "goal": {
            "singular": "objectif",
            "plural": "objectifs"
        },
        "challenge": {
            "singular": "défi",
            "plural": "défis"
        }
    },
    "seeMoreText": "…voir plus",
    "adjust_entry": "Veuillez ajuster l'entrée.",
    "overTracking": {
        "title": "Avertissement de sur-suivi",
        "desc1": {
            "singular": "Cette entrée sera auditée.",
            "plural": "Ces entrées seront auditées."
        },
        "desc2": "Un suivi excessif intentionnel peut entraîner la suspension du compte.",
        "button_edit": "Modifier mes entrées",
        "button_confirm": "Soumettre tel quel"
    },
    "oneEventAttendee": "1 participant",
    "multipleEventAttendees": "%{num} participants",
    "to": "à",
    "eventBonusFull": "Vous gagnerez %{number} %{points} bonus en participant à cet événement.",
    "eventBonusBold": "%{nomber} bonus %{points}",
    "didYouLikeArticle": "Avez-vous aimé cet article ? ",
    "didYouLikeVideo": "Avez-vous aimé cette vidéo ?",
    "tellUsMore": "Dites-nous en plus...",
    "thanksForFeedback": "Merci pour vos commentaires !",
    "challengesSubtitle": "Atteignez un objectif aux côtés d'autres participants ou jouez pour gagner ! ",
    "appStoreNameSprout": "Sprout at Work",
    "appStoreNameLiveBetter": "Medibank Live Better",
    "appStoreNameTelus": "Bien-être TELUS Santé",
    "huaweiStoreUrlSprout": "https:\/\/appgallery.huawei.com\/app\/C104993765",
    "telusHealthVirtualCare": "Soins Virtuels TELUS Santé",
    "virtualCare": "Soins Virtuels",
    "changePassword": {
        "telus": {
            "info": "Votre mot de passe est géré par votre compte %{telusVC}.",
            "button": "Changer mon mot de passe %{virtualCare}"
        }
    },
    "actions": "actions",
    "onAndUpcoming": "Sur et à venir",
    "termsAndPrivacyPolicyNew": "En continuant, vous acceptez les",
    "invitedToTeam": "Invité dans l'équipe de %{firstName} %{lastName}",
    "decline": "Déclin",
    "invitedToChallenge": "Invité par %{firstName} %{lastName}",
    "goalsCard": {
        "emptyStateTitle": "Vous n'avez aucun objectif fixé"
    },
    "huaweiStoreUrlTelus": "https:\/\/appgallery.huawei.com\/app\/C107357173",
    "challengesCard": {
        "emptyStateTitle": "Vous n'êtes confronté à aucun défi",
        "buttonLabel": "Explorez les défis"
    },
    "menu": "Menu",
    "everyone": "Tout le monde",
    "confirmEmployeeID": "Confirmer l'ID de l'employé",
    "employeeIDNoMatch": "Ces identifiants ne correspondent pas encore",
    "hidePost": "Masquer les messages de %{ownerName}",
    "hidingUserPostToast": {
        "success": {
            "title": "Masqué par l'utilisateur",
            "message": "Vous ne verrez plus les publications de cet utilisateur."
        }
    },
    "moderateHideUserDescription": "Masquer les publications de cet utilisateur supprimera le contenu spécifique à l'utilisateur du flux.",
    "startsInOneDay": "Commence dans 1 jour",
    "endsInOneDay": "Se termine dans 1 jour",
    "endsToday": "Se termine aujourd'hui",
    "hrisEmployeeID": {
        "infoModal": {
            "notInSystem": "n'est pas dans notre système. Avez-vous entré cela correctement?",
            "administrator": "Si vous êtes un nouvel employé, nous n'avons peut-être pas encore votre identifiant d'employé. Veuillez demander à votre administrateur quand réessayer.",
            "emailNotInSystem": "Si vous êtes un nouvel employé, votre adresse e-mail n'a peut-être pas encore été ajoutée à notre système. Veuillez demander à votre administrateur quand réessayer.",
            "eligibleEmail": "n’est pas une adresse e-mail éligible. L'avez-vous bien saisi ?"
        }
    },
    "oneMember": "1 membre",
    "programCode": {
        "infoModal": {
            "unique": "Votre entreprise possède un code de programme unique qui vous est généralement fourni par e-mail.",
            "support": "Si vous ne trouvez pas votre code, contactez l'administrateur de votre programme de bien-être ou envoyez un e-mail à support@sproutatwork.com avec le nom de votre entreprise."
        },
        "instructions": "Entrez le code du programme fourni par votre employeur pour commencer"
    },
    "whatsMyProgramCode": "Quel est mon code de programme ?",
    "enjoyApp": "Profitez de notre application mobile",
    "programCodeLabel": "Code de programme",
    "createdByMembersChallenges": "Créé par les membres",
    "invites": "Invitations",
    "recommendedContentTitle": "La bibliothèque sélectionne pour vous",
    "amountExchanged": "Montant échangé",
    "orderStatus": "Statut de la commande",
    "orderSuccessfulyyItemForConfirmation": "Commandez un succès! Une confirmation a été envoyée à %{email}.",
    "orderedOnDateText": "Ordonné sur %{OrderCreatedTime}",
    "personalize": {
        "communities": {
            "title": "Rejoignez des communautés",
            "description": "Les communautés relient les personnes ayant des intérêts communs. Vous pouvez rejoindre ou quitter des communautés à tout moment."
        },
        "objectives": {
            "title": "Mes objectifs",
            "description": "Que pouvons-nous vous aider à démarrer ou à maintenir ? Nous en profiterons pour améliorer vos recommandations."
        },
        "topics": {
            "title": "Mes sujets bien-être",
            "description": "Vous verrez plus de conseils et de contenu pratique sur ces sélections."
        }
    },
    "recommendedCardDesc": "Fixez-vous jusqu'à 3 objectifs pour vous concentrer sur l'amélioration de votre bien-être",
    "accessibility": {
        "track_activity": "Suivre l'activité",
        "cardbody": "Corps de la carte",
        "cardcontainer": "Conteneur de cartes",
        "cardfooter": "Pied de page de la carte",
        "unstartedChallengeHeader": "Défi non lancé",
        "activeOrEndedChallengeWrapper": "Emballage de défi",
        "activeOrEndedChallengeHeader": "En-tête du défi",
        "goalHeader": "En-tête d'objectif",
        "openOptions": "Options ouvertes"
    },
    "teams": {
        "teamInvites": "Invitations d'équipe",
        "findTeam": "Trouver une équipe",
        "teamFull": "L'équipe est complète"
    },
    "deleteAccountText": "Supprimez définitivement votre compte Sprout At Work et toutes ses données",
    "deleteAccountButtonTitle": "Supprimer mon compte",
    "joinTeamActionSheetText": "Rejoignez ou créez une équipe pour participer à ce challenge",
    "frequencyNone": "aucun",
    "quickLinkTitle": "Liens rapides",
    "moreTab": "Plus",
    "addedBy": "Ajouté par %{companyName}",
    "teamsTitle": "Équipes",
    "helpAndSupport": "Aide et support de l'application",
    "feedbackTitle": "Donnez votre avis",
    "feedbackDescription": "Dites-nous ce que vous aimez dans l'application et où nous pouvons nous améliorer.",
    "leaveTeamAction": "Quitter l'équipe",
    "teamActions": "Actions d'équipe",
    "leaveTeamLeaveChallenge": "Quitter cette équipe signifie que vous quittez le défi. Vous devrez rejoindre une équipe pour continuer à participer.",
    "familyMembers": "Membres de la famille",
    "familyMembersDescription": "Les membres de la famille doivent être âgés de plus de 16 ans. Ils auront un accès et une visibilité complets sur l’ensemble de la plateforme.",
    "learnMoreButton": "Apprendre encore plus",
    "thvcSelection": {
        "signUpUsingTelus": "Inscrivez-vous à l'aide de votre compte Soins virtuels de TELUS Santé",
        "loginGetStarted": "Connectez-vous à Virtual Care pour commencer",
        "haveAccount": "Avez-vous un compte Virtual Care?",
        "emailHelp": "Besoin d'aide? Contactez notre équipe d'assistance au",
        "yes": "Oui",
        "signMeUp": "Non, inscrivez-moi"
    },
    "inviteFamilyMember": {
        "label": "Inviter un membre de la famille",
        "btn": "Envoyer une invitation",
        "email": "Adresse email*",
        "firstName": "Prénom*",
        "lastName": "Nom de famille*",
        "approval": "Je confirme que j'ai l'approbation pour inviter ce membre de la famille à %{company}",
        "multiSelect1": "Ce membre de la famille a-t-il atteint l'âge de la majorité dans votre région ?",
        "multiSelect2": "Ce membre de la famille est-il âgé d'au moins 16 ans ?",
        "confirmTermsPolicy": "Je confirme que je suis le tuteur légal de cette personne. À mon avis, la personne à charge est suffisamment mature pour accepter l’utilisation de la plateforme, et j’accepte qu’elle y rejoigne. J'expliquerai aux personnes dépendantes la nécessité d'une conduite responsable sur la plateforme et la manière dont la plateforme collecte et utilise leurs données.",
        "onTheirBehalf": "en leur nom.",
        "confirm": "Oui, je confirme ce qui précède",
        "warning": "Le membre de la famille doit être âgé d'au moins 16 ans pour s'inscrire",
        "errorMsg": "Veuillez examiner les erreurs avant d'essayer de continuer"
    },
    "deleteFamilyMember": {
        "desc": "La suppression du compte d’un membre de la famille est définitive.",
        "btn": "Supprimer un membre de la famille",
        "confirmation": {
            "title": "Membre de la famille supprimé",
            "desc": "Le compte de %{fullName} a été supprimé"
        },
        "areYouSure": "Êtes-vous sûr de vouloir supprimer le compte de %{fullName}?"
    },
    "familyInvitationStatus": {
        "active": "Actif",
        "sent": "Invitation envoyée"
    },
    "familyInvitationSent": {
        "title": "E-mail d'invitation envoyé",
        "desc": "Inviter envoyé à %{fullName}"
    },
    "programCodeSignup": "Code de programme: %{programCode}",
    "notJoinedCommunityLabel": "Rejoignez cette communauté pour voir ce que les membres partagent",
    "moda": {
        "installApp": {
            "title": "Veuillez noter : les membres de Moda Health ne peuvent accéder à Sprout at Work que via leur tableau de bord de membre.",
            "subtitle": "Pour utiliser Sprout at Work sur votre smartphone :",
            "stepOneA": "1. Installez l'application mobile Sprout at Work.",
            "stepOneB": "Ne vous inscrivez pas et ne vous connectez pas sur l'application mobile.",
            "stepTwo": "2. Connectez-vous à votre tableau de bord membre sur votre téléphone mobile",
            "stepThree": "3. Accédez au programme de bien-être Sprout et suivez le lien : l'application mobile Sprout at Work devrait s'ouvrir."
        }
    },
    "HRISLocationSelection": {
        "title": "Dans quel pays travaillez-vous ?"
    },
    "visibilitySettings": {
        "title": "Paramètres de visibilité",
        "desc1": "Est-il possible d'être visible par les autres membres de l'application Bien-être de votre entreprise ?",
        "desc2": "Vous pourrez toujours modifier cela plus tard.",
        "moreTextQ1": "Que peuvent voir les autres ?",
        "moreTextAnswer1": "Votre nom, votre photo de profil et les détails de base de votre profil (comme le service et l'emplacement) peuvent être vus par les personnes de votre entreprise. Cela rend l'application plus sociale et amusante.",
        "moreTextQ2": "Où est-ce que j'apparais ?",
        "moreTextAnswer2": "Vous serez affiché en tant que participant aux défis, aux communautés et aux événements auxquels vous rejoignez, dans les classements et dans les résultats de recherche. Vous pourrez ajuster cela plus tard.",
        "moreTextAnswer3": "Nous ne partageons ni ne montrons vos informations personnelles sur la santé, comme votre taille, votre poids ou l’activité que vous suivez.",
        "btnAgree": "C'est bon de me montrer",
        "btnDisagree": "Ne laissez pas les autres membres me voir"
    },
    "privacyPolicyReadMore": "Pour en savoir plus, lisez notre Politique de confidentialité",
    "tellMeMore": "Dis m'en plus",
    "helpUsImprove": {
        "title": "Aidez-nous à améliorer",
        "desc1": "Nous utilisons des outils qui enregistrent des données d'utilisation anonymes. L'observation des tendances dans ce que les gens consultent et cliquent nous aide à améliorer l'application.",
        "desc2": "Vous pouvez désactiver cette option à tout moment.",
        "moreTextQ1": "Ce que nous regardons",
        "moreTextAnswer1": "Nous nous intéressons aux tendances et aux statistiques globales, c’est pourquoi nous n’examinons pas les données au niveau individuel.",
        "moreTextQ2": "Nous ne partageons pas vos données",
        "moreTextAnswer2": "Ces données ne sont disponibles que pour les personnes qui créent cette application pour contribuer à l'améliorer. Nous ne le partageons pas avec d’autres entreprises, y compris votre employeur.",
        "moreTextQ3": "Vos données sont anonymes",
        "moreTextAnswer3": "Nos outils n’enregistrent pas votre nom, votre emplacement exact ou toute information personnelle sur votre santé.",
        "btnAgree": "Suivre mon utilisation de manière anonyme",
        "btnDisagree": "Je n'accepte pas le suivi"
    },
    "deleteAccountTextAppName": "Supprimez définitivement votre compte %{appName} et toutes ses données",
    "anonymousMember": "Membre anonyme",
    "activitiesToTrack": {
        "title": "Activités à suivre"
    },
    "includedInMembership": "Inclus dans votre adhésion",
    "invalidDate": "Date invalide",
    "discardsStreamPost": {
        "discardTitle": "Supprimer le message ?",
        "discardChangesTitle": "Supprimer les modifications ?",
        "discardPostText": "Êtes-vous sûr de vouloir supprimer votre message ?",
        "discardPostChangesText": "Êtes-vous sûr de vouloir annuler vos modifications ?"
    },
    "trackActivityModalTitle": "Suivi pour %{date}",
    "noPosts": "Aucun message à voir",
    "goalIcon": "Icône d'objectif",
    "resetsOn": "Réinitialisation le %{date}",
    "clickForHelp": "Cliquez ici pour obtenir de l'aide",
    "trackActivityInputLabel": "Saisissez %{unit} %{activityName} %{dateFormat}",
    "itemsFound": "Objets trouvés",
    "tagState": {
        "active": "Actif",
        "notActive": "Pas actif"
    },
    "bonusCheckmarkLabel": "Vous avez reçu %{bonusLabel} points bonus pour avoir terminé",
    "searchBar": {
        "searching": "recherche %{term}",
        "result": "résultats de recherche"
    },
    "activityProgress": "Progression de l'activité - %{levelName} %{percentFilled}% - Réinitialisation dans %{daysLeft} jours",
    "bookmark": {
        "remove": "Supprimer des éléments enregistrés",
        "save": "Enregistrez cet article"
    },
    "bonusMark": {
        "earn": "Gagnez %{qté} %{points}",
        "earned": "Vous avez gagné %{qty} %{points}"
    },
    "tabToTrackActivity": "Appuyez pour suivre l'activité",
    "videoElementLabel": "%{title}, durée %{duration}, appuyez deux fois pour lire la vidéo",
    "updatedPoliciesPopup": {
        "title": "Nous avons mis à jour nos conditions",
        "details": "Nous vous encourageons à lire nos politiques mises à jour ci-dessous :",
        "disclaimer": "En cliquant sur le bouton ci-dessous, vous acceptez et reconnaissez les politiques mises à jour.",
        "agree": "Je suis d'accord"
    },
    "editActivityLog": {
        "canNotEditItem": "Vous ne pouvez pas modifier cette entrée",
        "canNotEditItemDescription": "La modification n'est pas disponible pour les activités synchronisées à partir d'appareils ou d'applications.",
        "updatedItem": "Activité mise à jour",
        "updatedItemDescription": "Vos modifications ont été enregistrées."
    },
    "login_with_email": "Connectez-vous avec votre e-mail",
    "healthconnect_not_available": "無法連線到 Health Connect。在 Health Connect 應用程式中，請確保已啟用權限。",
    "registrationField": {
        "required": {
            "firstName": "Veuillez entrer votre prénom",
            "lastName": "Veuillez entrer votre nom de famille",
            "email": "S'il vous plaît, mettez une adresse email valide",
            "password": "Veuillez entrer un mot de passe valide"
        }
    },
    "settingsErrorMessage": {
        "firstName": "Veuillez entrer votre prénom",
        "lastName": "Veuillez entrer votre nom de famille"
    },
    "requiredValidValue": "Veuillez saisir une valeur valide pour votre %{value}",
    "passwordHidden": "Mot de passe masqué, appuyez pour afficher le mot de passe",
    "passwordShown": "Mot de passe affiché, appuyez pour masquer le mot de passe",
    "libraryHeaderContent": {
        "category": "",
        "points": "Gagnez %{points} points."
    },
    "scoreCurrentPeriod": "%{text} va du %{startDate} au %{endDate}",
    "scoreCurrent": "%{text} correspond à %{points} points",
    "abbotResetPasswordModal": {
        "title": "Essayez-vous d'accéder à un compte de l'année dernière ?",
        "text": " Si vous vous êtes inscrit au défi de l’année dernière, ce compte ne fonctionnera plus. Vous devez vous inscrire pour cette année.",
        "goToResetPasswordBtn": "Je me suis inscrit en %{currentYear}",
        "goToSignupBtn": "Je ne me suis pas inscrit en %{currentYear}"
    },
    "challengeRegistrationClosed": "Inscriptions clôturées – Le défi a commencé",
    "stopSupportGoogleFit": {
        "banner": {
            "title": "Google Fit ne sera plus disponible",
            "description": "Basculez vers Health Connect pour continuer à suivre automatiquement votre activité.",
            "linkBtn": "Basculer vers Health Connect"
        },
        "newFeatureModal": {
            "label": "Action requise",
            "title": "Google Fit ne prend plus en charge la synchronisation des activités",
            "web": {
                "doNotHaveApp": "Vous n'avez pas encore notre application?",
                "getAppText": "Téléchargez-la ici,",
                "dateNotIncludedDescription": "Utilisez votre téléphone intelligent pour basculer vers Health Connect de Google.",
                "dateIncludedDescription": "Nous supprimerons l'intégration Google Fit le %{date}. Utilisez votre téléphone intelligent pour basculer Health Connect de Google."
            },
            "mobile": {
                "dateNotIncludedDescription": "Basculez vers Health Connect pour continuer à suivre automatiquement votre activité.",
                "dateIncludedDescription": "Nous supprimerons l'intégration Google Fit le %{date}. Basculez vers Health Connect pour continuer à suivre automatiquement votre activité.",
                "buttonLabel": "Basculer vers Health Connect"
            }
        }
    },
    "RBCTaxableRewardWarning": "Veuillez noter que toute récompense échangée via la plateforme de bien-être sera considérée comme un avantage imposable et la valeur correspondante sera reflétée comme revenu sur votre bulletin de paie."
};